<template>
  <div class="business-units">
    <div class="content">
      <div class="wrapper">
        <div class="wrap">
          <!-- [ Tree ] start -->
          <div class="wrap__tree" ref="wrap__tree">
            <div class="nav-project">
              <div class="nav-project_first-row">
                <div v-if="!isWorkDay" id="fade-in">
                  <div class="select-wrapper">
                    <label class="t-label"
                           for="business-centre">
                      Business Centre
                    </label>
                    <el-select
                        class="inputs"
                        id="business-centre"
                        no-data-text="no date"
                        v-model="valueBusinessCenter"
                        :placeholder="$t('bu_select_business_center')"
                        size="mini">
                      <el-option
                          v-for="item in businessCenters"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="setValueBusinessUnits(item.id)">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="select-wrapper">
                    <label
                        class="t-label"
                        for="business-unit">
                      Business Unit
                    </label>
                    <el-select
                        class="inputs"
                        no-data-text="no date"
                        id="business-unit"
                        v-model="valueBusinessUnit"
                        :placeholder="$t('bu_select_business_unit')"
                        size="mini">
                      <el-option
                          v-for="item in businessUnits"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="setBusinessUnitRowDataInput(item.id, 'first')">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                    <div v-if="isWorkDay" class="work-day-block">
                      <el-button class="close-work-day-btn" @click="closeMyWorkDay" size="mini" border type="primary" plain>{{$t('bu_btn_close_my_workday')}}</el-button>
                      <router-link :to="`/users?companyId=${this.$route.query.companyId}`">
                        <el-button @click="setMyWorkDay" size="mini" type="primary" plain>{{$t('bu_btn_set_my_workday')}}</el-button>
                      </router-link>
                    </div>
              </div>
              <div>
                <el-dropdown @command="handleCommand">
                  <el-button class="nav-tree__item" size="small" type="menu" icon="el-icon-edit-outline">{{$t('bu_dropdown_action')}}</el-button>
                  <el-dropdown-menu slot="dropdown">
                    <!--<el-dropdown-item command="changeWorkDay" :disabled="isWorkDay || !businessUnitPermission.actionMyWorkday" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-tickets">{{$t('bu_dropdown_action_my_workday')}}</el-dropdown-item>-->
                    <el-dropdown-item command="addTask" :disabled="disabledBtn || isWorkDay || !businessUnitPermission.createTask" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">{{$t('bu_dropdown_action_add_task')}}</el-dropdown-item>
                    <el-dropdown-item command="duplicateTask" :disabled="disabledBtn || isWorkDay || !businessUnitPermission.createTask" v-show="selectedRow.type !== 'businessUnit'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">{{$t('bu_dropdown_action_duplicate_task')}}</el-dropdown-item>
                    <el-dropdown-item command="editTask" :disabled="disabledBtn || isWorkDay || !businessUnitPermission.updateTask" v-show="selectedRow.type !== 'businessUnit'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">{{$t('bu_dropdown_action_edit_task')}}</el-dropdown-item>
                    <el-dropdown-item command="deleteTask" :disabled="disabledBtn || isWorkDay || !businessUnitPermission.deleteTask" v-show="selectedRow.type !== 'businessUnit'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-delete">{{$t('bu_dropdown_action_delete_task')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="disabledBtn || isWorkDay  || !businessUnitPermission.actionSaveTree" command="saveTaskTree" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-star-off">{{$t('bu_dropdown_action_save_business_unit_tree')}}</el-dropdown-item>
                    <el-dropdown-item command="inviteUser" :disabled="disabledBtn || !companyLayout.permission.inviteUser" v-show="selectedRow.type !== 'businessUnit'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">{{$t('bu_dropdown_action_invite_user')}}</el-dropdown-item>
                    <el-dropdown-item v-if="companyLayout" command="createEngagement" :disabled="disabledBtn || !businessUnitPermission.actionCreateEngagement" v-show="selectedRow.type === 'businessUnit'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">{{$t('engagement_dropdown_action_create_engagement')}}</el-dropdown-item>
                    <el-dropdown-item v-if="companyLayout" command="createProject" :disabled="disabledBtn || !businessUnitPermission.actionAddProject" v-show="selectedRow.type === 'businessUnit'" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">{{$t('project_dropdown_action_create_project')}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div style="width:100%; height: calc(100% - 113px); position: relative;">
              <span v-if="!isWorkDay" class="collapse-btn" @click="expandAll">{{expand ? $t('bu_closeAllTasks') : $t('bu_showAllTasks')}}</span>
              <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" id="myGrid"
                           :gridOptions="gridOptions"
                           @grid-ready="onGridReady"
                           :columnDefs="columnDefs"
                           :rowData="rowData"
                           :defaultColDef="defaultColDef"
                           :components="components"
                           :treeData="true"
                           :animateRows="true"
                           :groupDefaultExpanded="groupDefaultExpanded"
                           :getDataPath="getDataPath"
                           :getRowNodeId="getRowNodeId"
                           :frameworkComponents="frameworkComponents"
                           :autoGroupColumnDef="autoGroupColumnDef"
                           :getRowHeight="getRowHeight"
                           :getContextMenuItems="getContextMenuItems"
                           @row-drag-move="onRowDragMove"
                           @row-drag-leave="onRowDragLeave"
                           @row-drag-end="onRowDragEnd"
                           :rowSelection="rowSelection"
                           @selection-changed="onSelectionChanged"
                           :floatingFilter="true"
                           :suppressHorizontalScroll="true"
                           :rowClassRules="rowClassRules"></ag-grid-vue>
            </div>
          </div>
          <!--{{activeTab}}<br>-->
          <!--{{activeTaskInfoTab}}-->
          <!--{{selectedRow}}-->
          <!--{{activeCRMTab}}<br>-->
          <!--{{activeSCMTab}}<br>-->
          <!--{{activeAccountTHINKTab}}<br>-->
          <!--{{documentList}}-->
          <!--{{bookmarkList.info}}-->
          <!-- [ Tree ] end -->
          <!-- [Tree info] start -->
          <div class="wrap__info">
            <div class="nav-project">
              <div>
                <el-dropdown placement="bottom-start" @command="handleCommand">
                  <el-button style="margin-right: 20px;" class="nav-tree__item" size="small" type="menu" icon="el-icon-edit-outline">{{$t('bu_dropdown_function')}}</el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :disabled="selectedRow.type !== 'businessUnit'" command="toggleBusinessUnitBookmark" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_businessUnitBookmark')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!businessUnitPermission.functionCreateEstimate || true" command="createBusinessUnitEstimate" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_create_estimate')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!businessUnitPermission.functionCreateQuotation || true" command="createBusinessUnitQuotation" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_create_quotation')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!businessUnitPermission.functionCreateSalesOrder || true" command="createProjectSalesOrder" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_create_sales_order')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!businessUnitPermission.functionCreateInvoice || true" command="createBusinessUnitInvoice" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_create_invoice')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!businessUnitPermission.functionRequestPurchase || true" command="purchaseRequest" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_purchase_request')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!businessUnitPermission.functionAddPayment || true" command="addBusinessUnitPayment" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_add_payment')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!businessUnitPermission.functionCreateCreditNote || true" command="createBusinessUnitCreditNote" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_create_credit_note')}}</el-dropdown-item>
                    <!-- <el-dropdown-item :disabled="!isBusinessUnit || !businessUnitPermission.functionAddExpense || true" command="addBusinessUnitExpense" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_add_expense')}}</el-dropdown-item> -->
                    <el-dropdown-item :disabled="!isBusinessUnit || !businessUnitPermission.functionAddExpense || true" command="addBusinessUnitExpense" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_add_expense')}}</el-dropdown-item>
                    <!--tasks-->
                    <el-dropdown-item :disabled="isBusinessUnit" command="toggleBusinessUnitTaskBookmark" divided class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_bookmarkTask')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!businessUnitPermission.functionCreateTaskEstimate || true" command="createTaskEstimate" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_create_task_estimate')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!businessUnitPermission.functionRequestCashAdvance || true" command="createCashAdvance" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_request_cash_advance')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="isBusinessUnit || !businessUnitPermission.functionAddTaskExpense || true" command="addTaskExpense" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_add_task_expense')}}</el-dropdown-item>
                    <el-dropdown-item command="addTaskTimer" :disabled="isBusinessUnit || selectedRow.type !== 'Task' || (selectedRow.taskStatus !== 2 && selectedRow.taskStatus !== 5) || !businessUnitPermission.functionStartTaskTimer" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('bu_dropdown_function_start_task_timer')}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-button :disabled="!businessUnitPermission.functionCalander || !$route.query.businessUnitId" @click="openScheduler" style="margin-right: 10px;" class="nav-tree__item" size="small" type="menu2" icon="el-icon-menu">{{$t('bu_btn_calander')}}</el-button>
                <!--<el-button :disabled="!businessUnitPermission.functionCharts" @click="underDevelopment" style="margin-right: 10px;" class="nav-tree__item" size="small" type="menu2" icon="el-icon-menu">{{$t('bu_btn_gant')}}</el-button>-->
                <el-button :disabled="!businessUnitPermission.functionReports" @click="underDevelopment" style="margin-right: 10px;" class="nav-tree__item" size="small" type="menu2" icon="el-icon-menu">{{$t('bu_btn_reports')}}</el-button>
              </div>
            </div>
            <el-tabs type="border-card" v-model="activeTab" @tab-click="handleClick">
              <el-tab-pane v-if="selectedRow.type === 'businessUnit'" :disabled="disabledBtn || !businessUnitPermission.viewInfo" :label="$t('bu_tab_info')" name="first">
                <InfoTab ref="infoTab"
                         v-if="!disabledBtn"
                         v-model="activeInfoTab"
                         :companyLayout="companyLayout"
                         :selectedRow="selectedRow"
                         :projectInfo="projectInfo"
                         @setNewPermissions="setNewPermissions"
                         :businessUnitPermission="businessUnitPermission"
                />

              </el-tab-pane>
              <el-tab-pane  v-else :disabled="disabledBtn || !businessUnitPermission.viewTaskInfo" :label="$t('bu_tab_info')" name="taskInfoTab">
                <bu-info-task-tab
                        ref="taskInfoTab"
                        v-model="activeTaskInfoTab"
                        v-if="!disabledBtn"
                        :selectedRow="selectedRow"
                        :bookmarkList="bookmarkList"
                        :taskInfo="taskInfo"
                        :businessUnitPermission="businessUnitPermission"

                        :progressData="progressData"
                        :selectedTaskForInfo="selectedTaskForInfo"
                        :selectedRowId="selectedRow.id"
                        :activeBusinessUnitId="activeBusinessUnitId"
                        @getProjects="setBusinessUnitRowDataInput"/>
              </el-tab-pane>

              <el-tab-pane :disabled="disabledBtn || !businessUnitPermission.viewFiles" v-if="isBusinessUnit" :label="$t('bu_tab_files')" name="third">
                <businessUnitsFilesTabNew :bookmarkListBusinessUnit="bookmarkListBusinessUnit" :businessUnitPermission="businessUnitPermission" :selectedRow="selectedRow" v-if="!disabledBtn" />
              </el-tab-pane>

              <el-tab-pane :disabled="disabledBtn || !businessUnitPermission.viewTaskFiles" v-else :label="$t('bu_tab_files')" name="four">
                <taskFilesTabNew v-if="!disabledBtn" :selectedRow="selectedRow" :bookmarkList="bookmarkList" :businessUnitPermission="businessUnitPermission"/>
              </el-tab-pane>

              <!-- v-if="selectedRow.type === 'Task' && selectedRow.isReoccuring === 1 || selectedRow.type === 'Task' && selectedRow.hasProgress === 1" -->
              <el-tab-pane :disabled="disabledBtn" v-if="false" :label="$t('bu_tab_progress')" name="second">
                <DepProgressTab
                        v-if="!disabledBtn"
                        :selectedRow="selectedRow"
                        :businessUnitPermission="businessUnitPermission"
                        :bookmarkList="bookmarkList"
                        :progressData="progressData"
                        :selectedTaskForInfo="selectedTaskForInfo"
                        :selectedRowId="selectedRow.id"
                        @submit="setBusinessUnitRowDataInput" />
              </el-tab-pane>

              <el-tab-pane :disabled="disabledBtn || !businessUnitPermission.viewComments" v-if="isBusinessUnit" :label="$t('bu_tab_comments')" name="businessUnitCommentTab">
                <businessUnitCommentsTab ref="businessUnitCommentTab" :businessUnitPermission="businessUnitPermission" v-if="!disabledBtn" :selectedRow="selectedRow" :bookmarkListBusinessUnit="bookmarkListBusinessUnit"/>
              </el-tab-pane>

              <el-tab-pane :disabled="disabledBtn || !businessUnitPermission.viewTaskComments" v-else :label="$t('bu_tab_comments')" name="businessUnitTaskCommentTab">
                <taskCommentsTab
                        ref="businessUnitTaskCommentTab"
                        :bookmarkList="bookmarkList"
                        :selectedRow="selectedRow"
                        v-if="!disabledBtn"
                        :businessUnitPermission="businessUnitPermission"/>
              </el-tab-pane>

              <el-tab-pane :disabled="disabledBtn || !businessUnitPermission.viewMessages" v-if="isBusinessUnit" :label="$t('bu_tab_messages')" name="seven">
                <MessagesProject v-if="!disabledBtn" type="businessUnit" :bookmarkListProject="bookmarkListBusinessUnit" :selectedRow="selectedRow" ref="MessagesProject" :activeProjectId="activeBusinessUnitId"/>
              </el-tab-pane>

              <el-tab-pane :disabled="disabledBtn || !businessUnitPermission.viewTaskMessages" v-else :label="$t('bu_tab_messages')" name="eight">
                <MessagesTask v-if="!disabledBtn" type="taskBusinessUnit" :selectedRow="selectedRow" ref="MessagesTask" :bookmarkList="bookmarkList" :activeProjectId="activeBusinessUnitId"/>
              </el-tab-pane>

              <el-tab-pane :disabled="disabledBtn || !businessUnitPermission.viewMeetings" v-if="isBusinessUnit" :label="$t('bu_tab_meetings')" name="nine">
                <businessUnitMeetings
                        ref="businessUnitMeetingTab"
                        :businessUnitCompanyVendorList="businessUnitCompanyVendorList"
                        :businessUnitCompanyClientList="businessUnitCompanyClientList"
                        :businessUnitPermission="businessUnitPermission"
                        :bookmarkListBusinessUnit="bookmarkListBusinessUnit"
                        :selectedRow="selectedRow" />
              </el-tab-pane>
              <el-tab-pane :disabled="disabledBtn || !businessUnitPermission.viewTaskMeetings" v-else :label="$t('bu_tab_meetings')" name="ten">
                <businessUnitTaskMeetings
                        ref="businessUnitTaskMeetingTab"
                        :businessUnitPermission="businessUnitPermission"
                        :businessUnitTaskPersonVendorList="businessUnitTaskCompanyVendorPersonList"
                        :businessUnitTaskCompanyClientPersonList="businessUnitTaskCompanyClientPersonList"
                        :bookmarkList="bookmarkList"
                        :selectedRow="selectedRow"/>
              </el-tab-pane>

              <!-- v-if="!isBusinessUnit" -->
              <!--<el-tab-pane :disabled="disabledBtn || !businessUnitPermission.viewDocuments" v-if="false" :label="$t('bu_tab_documents')" name="fourteen">-->
                <!--<DocumentsTask  ref="docs" :businessUnitPermission="businessUnitPermission" :bookmarkList="bookmarkList" :selectedRow="selectedRow"/>-->
              <!--</el-tab-pane>-->

              <!-- CRM -->
              <el-tab-pane :disabled="disabledBtn || !businessUnitPermission.viewCRM || !businessUnitPermission.viewTaskCRM" :label="$t('bu_tab_crm')" name="crm">
                <CRM
                        v-model="activeCRMTab"
                        :isBusinessUnit="isBusinessUnit"
                        :selectedRow="selectedRow"
                        ref="crm"
                        :bookmarkList="bookmarkList"
                        :bookmarkListBusinessUnit="bookmarkListBusinessUnit"
                        :businessUnitPermission="businessUnitPermission"/>
              </el-tab-pane>

              <!-- SCM -->
              <el-tab-pane :disabled="disabledBtn || !businessUnitPermission.viewSCM || !businessUnitPermission.viewTaskSCM" :label="$t('bu_tab_scm')" name="scm">
                <SCM
                        v-model="activeSCMTab"
                        :isBusinessUnit="isBusinessUnit"
                        :selectedRow="selectedRow"
                        ref="scm"
                        :bookmarkList="bookmarkList"
                        :bookmarkListBusinessUnit="bookmarkListBusinessUnit"
                        :businessUnitPermission="businessUnitPermission"/>
              </el-tab-pane>

              <!-- aTHINK -->
              <el-tab-pane :disabled="disabledBtn || !businessUnitPermission.viewAT || !businessUnitPermission.viewTaskAT" :label="$t('bu_tab_at')" name="aTHINK">
                <aTHINKTab
                        v-model="activeAccountTHINKTab"
                        :isBusinessUnit="isBusinessUnit"
                        :selectedRow="selectedRow"
                        ref="aTHINK"
                        :bookmarkList="bookmarkList"
                        :bookmarkListBusinessUnit="bookmarkListBusinessUnit"
                        :businessUnitPermission="businessUnitPermission"/>
              </el-tab-pane>

            </el-tabs>

          </div>
          <!-- [Tree info] end -->
        </div>
      </div>
    </div>

    <!-- [ Modal form Create Project] start -->
    <CreateBusinessUnitTask ref="createBusinessUnitTaskModal" :selectedRow="selectedRow" @submit="setBusinessUnitRowDataInput"/>
    <!-- [ Modal form Create Project] end -->

    <!-- [ Modal form Create Project] start -->
    <CreateProjectModal ref="createProjectModal" />
    <!-- [ Modal form Create Project] end -->

    <!-- [ Modal form Create Engagement] start -->
    <CreateEngagementModal ref="createEngagementModal" />
    <!-- [ Modal form Create Engagement] end -->

    <!-- [ Modal after drag end ] start-->
    <sweet-modal blocking width="400" ref="dragEnd">
      <div class="draggble">
        <h1>Action</h1>
          <el-button v-if="potentialParent.id !== 0" @click="createParentTask('1')" class="modal__btn btn" type="primary" plain size="mini">Move Task</el-button>
          <div><p>or</p></div>
          <el-button @click="createParentTask('0')" class="modal__btn btn" type="primary" plain size="mini">Add to parent</el-button>
      </div>
    </sweet-modal>
    <!-- [ Modal after drag end ] start-->
    <CreateBusinessUnitTemplate @getTreeScreen="getTreeScreen" ref="modal777"/>
    <!-- [ Modal task not found ] end-->

    <!-- [ Create Expense Modal] start-->
    <businessUnitExpenseModal :selectedRow="selectedRow" ref="businessUnitExpenseModal"/>
    <!-- [ Create Expense Modal ] end-->

    <!-- [ Create Cash Advance Modal] start-->
    <businessUnitCashAdvanceModal :selectedRow="selectedRow" ref="businessUnitCashAdvanceModal"/>
    <!-- [ Create Cash Advance Modal ] end-->

    <!-- [ Modal Reassign Tasks start -->
    <ReassignTasksModal
            :selectedRows="selectedRows"
            :activeBusinessUnitId="activeBusinessUnitId"
            ref="ReassignTasksModal"
            :rowData="rowData"
            @submit="setBusinessUnitRowDataInput"/>
    <!-- [ Modal Reassign Tasks end -->

    <add-users-to-tasks-modal-b-u
            :selectedRows="selectedRows"
            :activeBusinessUnitId="activeBusinessUnitId"
            ref="addNewUserToTasksModal"
            :rowData="rowData"
            @submit="setBusinessUnitRowDataInput"/>

    <sweet-modal blocking ref="taskNotFound" icon="warning">
      <div class="task-not-found-block">
        <h3>Task has been deleted</h3>
      </div>
    </sweet-modal>
    <!-- [ Modal task not found ] start-->
    <!-- [ Modal Delete Task Confirmation start -->
    <!--<sweet-modal blocking ref="confirmation" title="Delete Task">-->
      <!--Are you sure you want to delete this Task?-->
      <!--<template slot="box-action">-->
        <!--<el-button class="button" @click="deleteConfirm">Delete Task</el-button> &nbsp;-->
      <!--</template>-->
    <!--</sweet-modal>-->
    <!-- [ Modal Delete Task Confirmation end -->
    <!--<sweet-modal blocking class="deleted-modal" ref="success" icon="success">-->
      <!--Delete successfully-->
    <!--</sweet-modal>-->
    <inviteUserModal ref="inviteUserModal"/>

    <sweet-modal blocking ref="addParent" class="modal-parent">
      Task already started, add sub task not permited, do you want to insert task?
      <el-button slot="button" v-on:click="$refs.addParent.close(),  $refs.createBusinessUnitTaskModal.openModal('insert')">Insert task</el-button>
    </sweet-modal>

    <!-- document modal -->
    <!--<el-dialog-->
      <!--:title="(documentList.type)"-->
      <!--:visible.sync="dialogVisible"-->
      <!--width="40%"-->
      <!--:before-close="handleClose">-->
      <!--<span>You have documents that require action.</span>-->
      <!--<span slot="footer" class="dialog-footer">-->
        <!--&lt;!&ndash; <el-button @click="dialogVisible = false">Cancel</el-button> &ndash;&gt;-->
        <!--<el-button type="primary" @click="signDocument">Go</el-button>-->
      <!--</span>-->
    <!--</el-dialog>-->

    <!-- [ Modal Under Development ] end -->
    <sweet-modal blocking ref="underDevelopment" icon="warning">
        <div class="task-not-found-block">
            <h3>Current Service Under Development</h3>
        </div>
    </sweet-modal>

    <!--<later-document-modal-b-u ref="laterDocumentModal" />-->
    <later-document-modal ref="laterDocumentModal"/>

    <scheduler-modal ref="schedulerModal"/>

  </div>
</template>

<script>
  import SchedulerModal from "../components/Projects/calendar/SchedulerModal";
  import log from '@/log/log.js'
  import { mapGetters } from 'vuex'
  import html2canvas from "html2canvas"
  import customTooltip from "../components/ag-grid-components/components/customTooltip";
  import businessUnitMeetings from '@/components/BusinessUnits/businessUnitMeetings.vue'
  import businessUnitTaskMeetings from '@/components/BusinessUnits/businessUnitTaskMeetings.vue'
  import VueDragResize from 'vue-drag-resize';
  // import Header from '@/components/Header.vue';
  // import Menu from '@/components/Menu.vue'
  import CreateProjectModal from '@/components/BusinessUnits/CreateProjectModal.vue';
  import CreateEngagementModal from '@/components/BusinessUnits/CreateEngagementModal.vue';
  // import businessUnitsFilesTab from '@/components/BusinessUnits/businessUnitsFilesTab.vue';
  import businessUnitsFilesTabNew from '@/components/BusinessUnits/businessUnitsFilesTabNew.vue';
  // import taskFilesTab from '@/components/BusinessUnits/taskFilesTab.vue';
  import taskFilesTabNew from '@/components/BusinessUnits/taskFilesTabNew.vue';
  import CreateProjectTaskProgressModal from '@/components/Projects/CreateProjectTaskProgressModal.vue';
  import CreateBusinessUnitTemplate from '@/components/BusinessUnits/createBusinessUnitTemplate.vue';
  import CreateBusinessUnitTask from '@/components/BusinessUnits/CreateBusinessUnitTask.vue';
  import InfoTab from '@/components/BusinessUnits/InfoTab.vue'
  import DepProgressTab from '@/components/BusinessUnits/DepProgressTab.vue'
  import {SweetModal} from '@totalflow4/tfsweet-modal-vue';
  import {AgGridVue} from 'ag-grid-vue';
  import axios from 'axios';
  import {VueEditor} from 'vue2-editor'
  import moment from 'moment'
  import _ from 'lodash';
  import businessUnitCommentsTab from '@/components/BusinessUnits/businessUnitCommentsTab.vue'
  import taskCommentsTab from '@/components/BusinessUnits/taskCommentsTab.vue'
  import inviteUserModal from '@/components/users/inviteUserModal.vue'
  import businessUnitExpenseModal from '@/components/Projects/projectExpenseModal.vue'
  import businessUnitCashAdvanceModal from '@/components/Projects/projectCashAdvanceModal.vue'
  // Messages
  import MessagesProject from '@/components/Projects/messages/MessagesProject.vue'
  import MessagesTask from '@/components/Projects/messages/MessagesTask.vue'
  // History
  import businessUnitHistory from '@/components/BusinessUnits/businessUnitHistoryTab.vue'
  import businessUnitTaskHistory from '@/components/BusinessUnits/businessUnitTaskHistoryTab.vue'
  // import DocumentsTask from '@/components/BusinessUnits/DocumentsTask.vue'
  //GRID ICONS
  import empty from "@/assets/img/grid/empty.svg"
  import timer from "@/assets/img/grid/timer.svg"
  import userDefault from '@/assets/img/user-default.jpg'
  import inProgress from "@/assets/img/grid/progress_icn.svg"
  import start from "@/assets/img/grid/start.svg"
  import pause from "@/assets/img/grid/pause.svg"
  import done from "@/assets/img/grid/marked.svg"

  import gridMessageBox from '@/components/Projects/gridMessageBox/main.js';
  // aTHINKTab
  import aTHINKTab from '@/components/BusinessUnits/accountTHINK/accountTHINK.vue'
  // CRM
  import CRM from '@/components/BusinessUnits/CRM/CRM.vue'
  // SCM
  import SCM from '@/components/BusinessUnits/SCM/SCM.vue'
  import ReassignTasksModal from '@/components/BusinessUnits/ReassignTasksModal.vue'
  import BuInfoTaskTab from "../components/BusinessUnits/infoTaskTab";
  // import LaterDocumentModalBU from "../components/BusinessUnits/laterDocumentModal/index";
  import LaterDocumentModal from "../components/documents/laterDocumentModal";
  import AddUsersToTasksModalBU from "../components/BusinessUnits/AddUsersToTasksModal";

  var potentialParent = null;

  function moveToPath(newParentPath, node, allUpdatedNodes) {
    var oldPath = node.data.filePath;
    var fileName = oldPath[oldPath.length - 1];
    var newChildPath = newParentPath.slice();
    newChildPath.push(fileName);
    node.data.filePath = newChildPath;
    allUpdatedNodes.push(node.data);
    if (node.childrenAfterGroup) {
      node.childrenAfterGroup.forEach(function(childNode) {
        moveToPath(newChildPath, childNode, allUpdatedNodes);
      });
    }
  }

  function isSelectionParentOfTarget(selectedNode, targetNode) {
    var children = selectedNode.childrenAfterGroup;
    for (var i = 0; i < children.length; i++) {
      if (targetNode && children[i].key === targetNode.key) return true;
      isSelectionParentOfTarget(children[i], targetNode);
    }
    return false;
  }

  function arePathsEqual(path1, path2) {
    if (path1.length !== path2.length) {
      return false;
    }
    var equal = true;
    path1.forEach(function(item, index) {
      if (path2[index] !== item) {
        equal = false;
      }
    });
    return equal;
  }

  function setPotentialParentForNode(api, overNode) {
    var newPotentialParent;
    if (overNode) {
      newPotentialParent = overNode.data.myType === "folder" ? overNode : overNode.parent;
    } else {
      newPotentialParent = null;
    }
    var alreadySelected = potentialParent === newPotentialParent;
    if (alreadySelected) {
      return;
    }
    var rowsToRefresh = [];
    if (potentialParent) {
      rowsToRefresh.push(potentialParent);
    }
    if (newPotentialParent) {
      rowsToRefresh.push(newPotentialParent);
    }
    potentialParent = newPotentialParent;
    refreshRows(api, rowsToRefresh);
  }

  function refreshRows(api, rowsToRefresh) {
    var params = {
      rowNodes: rowsToRefresh,
      force: true
    };
    api.refreshCells(params);
  }

  function getFileCellRenderer() {
    function FileCellRenderer() {}
    FileCellRenderer.prototype.init = function(params) {
      var tempDiv = document.createElement("div");
      var value = params.value;
      var icon = getFileIcon(params.value);
      tempDiv.innerHTML = icon ? '<i class="' + icon + '"/>' + '<span class="filename">' + value + "</span>" : value;
      this.eGui = tempDiv.firstChild;
    };
    FileCellRenderer.prototype.getGui = function() {
      return this.eGui;
    };
    return FileCellRenderer;
  }

  function getFileIcon(filename) {
    return filename.endsWith(".mp3") || filename.endsWith(".wav")
  }

  function getDateFromTimestamp(timestamp) {
    if (_.isString(timestamp) && timestamp.match(/^[0-9]+$/)) {
      return new Date(parseInt(timestamp));
    }
    if (_.isNumber(timestamp)) {
      return new Date(timestamp);
    }
  }

  function calcProjectProgress(projectTaskList) {
    if (projectTaskList.length == 0) {
      return 100;
    }
    var count = 0;
    var sum = projectTaskList.reduce(function (sumOfElements, item) {
      if (item.parentBusinessUnitTaskId == 0) {
        count++;
        return sumOfElements + parseInt(item.progress);
      }
      return sumOfElements;
    }, 0);
    return Math.round(sum / count);
  }

  function toId(value) {
    if (_.isNumber(value)) {
      return parseInt(value);
    }
    if (_.isNull(value) || _.isUndefined(value)) {
      return 0;
    }
    return 0;
  }
  function buildTree2(businessUnitTaskList) {
    var resultProjectTaskTree = []
    var todaysdate = moment();
    for (var index = 0; index < businessUnitTaskList.length; index++) {
      let reoccuringInDays = null;
      if(businessUnitTaskList[index].isReoccurring){
        const startTask = businessUnitTaskList[index].reoccuringStartDate;
        const todaysdate = moment().format('X');
        const repeatInterval = Number(businessUnitTaskList[index].repeatTaskInterval);
        const whenTaskStart = moment(startTask, 'X').add(repeatInterval, 'hours').format('LLLL');
        if(repeatInterval <= 24){
          reoccuringInDays = moment.utc(moment(whenTaskStart, 'LLLL').diff(moment(todaysdate, 'X'))).format("HH:mm")
        }else if(repeatInterval > 24){
          reoccuringInDays = Math.round(moment.duration(moment(whenTaskStart, 'LLLL').diff(moment(todaysdate, 'X'))).asDays())
        }
        if(startTask < Number(todaysdate)){
          reoccuringInDays = null
        }
      }
      let row = {
        id: businessUnitTaskList[index].id,
        name: businessUnitTaskList[index].name,
        filePath: [index],
        businessUnitId:businessUnitTaskList[index].businessUnitId,
        orderIndex:businessUnitTaskList[index].orderIndex,
        hasProgress:businessUnitTaskList[index].hasProgress,
        progress: Math.floor(businessUnitTaskList[index].progress),
        type: 'Task',
        timerCount:businessUnitTaskList[index].timerCount,
        reoccuring: reoccuringInDays === null ? '' : reoccuringInDays,
        isReoccuring: businessUnitTaskList[index].isReoccurring,
        taskStatus: businessUnitTaskList[index].status,
        myType: 'folder'
      }
      resultProjectTaskTree.push(row);
    }
    for (let i = 0; i < resultProjectTaskTree.length; i++){
      resultProjectTaskTree[i].myIndex = i.toString()
    }
    console.log('resultProjectTaskTree', resultProjectTaskTree)
    return resultProjectTaskTree;

  }

  function buildTree(project, projectTaskList, parentBusinessUnitTaskId, filePath) {
    if (!_.isArray(filePath)) {
      filePath = [];
    }
    var resultProjectTaskTree = [];
    if (project) {
      filePath = ['0'];
      resultProjectTaskTree.push({
        id: 0,
        name: project.name,
        filePath: filePath,
        // daysTotal: 0,
        // daysRemaning: 0,
        businessUnitId: project.id,
        progress: project.progress,
        type: 'businessUnit',
        reoccuring: project.repeatTaskInterval,
        orderIndex: 0,
        taskStatus: -1,
        myType: 'folder'
      });
    }
    for (var index = 0; index < projectTaskList.length; index++) {
      if (toId(projectTaskList[index].parentBusinessUnitTaskId) === toId(parentBusinessUnitTaskId)) {
        var newfilePath = filePath.concat([projectTaskList[index].id].toString());
        var childElementList = buildTree(null, projectTaskList, projectTaskList[index].id, newfilePath);
        let reoccuringInDays = null
        if(projectTaskList[index].isReoccurring){
          var startTask = projectTaskList[index].reoccuringStartDate
          // var startTaskForAdd = moment(projectTaskList[index].reoccuringStartDate, 'X')
          var todaysdate = moment().format('X')
          var repeatInterval = Number(projectTaskList[index].repeatTaskInterval)
          var whenTaskStart = moment(startTask, 'X').add(repeatInterval, 'hours').format('LLLL')
          if(repeatInterval <= 24){
            reoccuringInDays = moment.utc(moment(whenTaskStart, 'LLLL').diff(moment(todaysdate, 'X'))).format("HH:mm")
          }else if(repeatInterval > 24){
            reoccuringInDays = Math.round(moment.duration(moment(whenTaskStart, 'LLLL').diff(moment(todaysdate, 'X'))).asDays())
          }
          if(startTask < Number(todaysdate)){
            reoccuringInDays = null
          }
        }

        if (childElementList.length > 0) {
          resultProjectTaskTree.push({
            id: projectTaskList[index].id,
            name: projectTaskList[index].name,
            filePath: newfilePath,
            hasProgress:projectTaskList[index].hasProgress,
            businessUnitId:projectTaskList[index].businessUnitId,
            // daysTotal: daysBetween(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
            // daysRemaning: daysBetween(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
            progress: projectTaskList[index].progress,
            orderIndex:projectTaskList[index].orderIndex,
            timerCount:projectTaskList[index].timerCount,
            type: 'MasterTask',
            reoccuring: reoccuringInDays === null ? '' : reoccuringInDays,
            isReoccuring: projectTaskList[index].isReoccurring,
            taskStatus: projectTaskList[index].status,
            myType: 'folder'
          });
          resultProjectTaskTree = resultProjectTaskTree.concat(childElementList);
        } else {
          resultProjectTaskTree.push({
            id: projectTaskList[index].id,
            name: projectTaskList[index].name,
            filePath: newfilePath,
            businessUnitId:projectTaskList[index].businessUnitId,
            hasProgress:projectTaskList[index].hasProgress,
            // daysTotal: daysBetween(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
            // daysRemaning: daysBetween(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
            progress: projectTaskList[index].progress,
            orderIndex:projectTaskList[index].orderIndex,
            timerCount:projectTaskList[index].timerCount,
            type: 'Task',
            reoccuring: reoccuringInDays === null ? '' : reoccuringInDays,
            isReoccuring: projectTaskList[index].isReoccurring,
            taskStatus: projectTaskList[index].status,
            myType: 'folder'
          });
        }
      }
    }
    for (let i = 0; i < resultProjectTaskTree.length; i++){
      resultProjectTaskTree[i].myIndex = i.toString()
    }
    return resultProjectTaskTree;
  }


  export default {
    name: 'business-units',
    components: {
      AddUsersToTasksModalBU,
      LaterDocumentModal,
      // LaterDocumentModalBU,
      BuInfoTaskTab,
      businessUnitMeetings,
      businessUnitTaskMeetings,
      inviteUserModal,
      VueEditor,
      // Header,
      AgGridVue,
      SweetModal,
      gridMessageBox,
      CreateProjectModal,
      CreateEngagementModal,
      // businessUnitsFilesTab,
      businessUnitsFilesTabNew,
      // taskFilesTab,
      taskFilesTabNew,
      CreateBusinessUnitTask,
      ReassignTasksModal,
      // CreateTaskModal,
      CreateProjectTaskProgressModal,
      // ShareProjectTaskModal,
      businessUnitExpenseModal,
      businessUnitCashAdvanceModal,
      InfoTab,
      DepProgressTab,
      CreateBusinessUnitTemplate,
      // Menu,
      businessUnitCommentsTab,
      taskCommentsTab,
      MessagesProject,
      MessagesTask,
      businessUnitHistory,
      businessUnitTaskHistory,
      // DocumentsTask,
      VueDragResize,
      CRM,
      SCM,
      aTHINKTab,
      SchedulerModal,
    },
    create() {

    },
    computed: {
      ...mapGetters([
        'getStateId'
      ]),
      // myFirstCompanys() {
      //   return this.$store.state.user.companyList
      // },
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
      user() {
        return this.$store.state.user
      },
      // reoccuringTask(){
      //   return this.formAddTask.reoccuringTask
      // }
      businessUnitCompanyVendorList() {
        return this.projectInfo.businessUnitCompanyVendorList.length ? this.projectInfo.businessUnitCompanyVendorList : []
      },
      businessUnitTaskCompanyVendorPersonList() {
        return this.taskInfo.businessUnitTaskCompanyVendorPersonList.length ? this.taskInfo.businessUnitTaskCompanyVendorPersonList : []
      },
      businessUnitCompanyClientList() {
        return this.projectInfo.businessUnitCompanyClientList.length ? this.projectInfo.businessUnitCompanyClientList : []
      },
      businessUnitTaskCompanyClientPersonList() {
        return this.taskInfo.businessUnitTaskCompanyClientPersonList.length ? this.taskInfo.businessUnitTaskCompanyClientPersonList : []
      }
    },
    beforeMount() {
      this.gridOptions = {
        suppressCellSelection: true,
        isRowSelectable: function(rowNode) {
          // console.log('rowNode.data.access', rowNode.data.access, rowNode.data.name);
          return rowNode.data.access
        },
        overlayNoRowsTemplate: this.$i18n.t('general_noRowsToShow'),
      };
      this.columnDefs = [
        {
          headerName: "#",
          field: "myIndex",
          tooltipField: "myIndex",
          tooltipComponentParams: { fieldName: "Index" },
          width:20,
          cellClassRules: {
            "hover-over": params => {
              return params.node === potentialParent;
            }
          },
          cellRenderer: function(params) {
            return `<span class="txtRender">${params.node.data.myIndex}</span>`
          },
          cellStyle: function(params) {
            if (params.data.id === 0){
              return {'display':'none'}
            }else{
              return {'text-align': 'center; display: flex; justify-content:start; margin-left:10px;'}
            }
          }
        },
        {
          headerName: '',
          field: "reoccuring",
          cellClassRules: {
            "hover-over": params => {
              return params.node === potentialParent;
            }
          },
          width: 20,
          cellRenderer: function(params) {
            if(params.node.data.reoccuring){
              return `<span class="reoccuringRender">${params.node.data.reoccuring}</span>`
            }
          }
        },
        {
          headerName: "",
          field: "leader",
          // cellRenderer: "avatarRenderer",
          cellRenderer: function(params) {
            if(params.node.data.leader !== null ){
              if(params.node.data.leader.avatarUrl) return `<img class="imageRender" src=${params.node.data.leader.avatarUrl} />`;
              else return `<img class="imageRender" src=${userDefault} />`
            }else {
              return null
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
          tooltipField: "leader.fullName",
          tooltipComponentParams: { fieldName: "Assigner" },
          width: 12
        },
        {
          headerName: "",
          field: "daysRemaning",
          // cellRenderer: "dayRenderer",
          tooltipField: "daysRemaning",
          tooltipComponentParams: function (params) {
            // console.log('params--', params)
            const rowNode = params.api.getDisplayedRowAtIndex(params.rowIndex);
            // console.log(rowNode)
            if (rowNode.data.type === 'Task') {
              let numb = params.value.toString().match(/\d/g);
              numb = numb.join("");
              console.log('!!! PARAMS !!!', numb)
              console.log('!!! PARAMS !!!', params.value[0])
              if (params.value[0] === '(' && params.value[1] === '+') {
                return { fieldName: `Completed ${numb} Days Late` }
              }

              if (params.value[0] === '(' && params.value[1] === '-') {
                return { fieldName: `Completed ${numb} Days Early` }
              }

              if (params.value === '(0)') {
                return { fieldName: `Completed on Time` }
              }

              if (params.value === '0') {
                return { fieldName: `Due Today` }
              }

              if (params.value[0] === '+') {
                return { fieldName: `Overdue by ${numb} Days` }
              }

              if (params.value.toString() === '1'){
                return { fieldName: `Due in ${numb} Day` }
              }

              else {
                return { fieldName: `Due in ${numb} Days`}
              }
            } else if (rowNode.data.type === 'MasterTask') {
              return {fieldName: `Master Task`}
            }
          },
          cellRenderer: function(params) {
            let deadlineChildTasks = [];
            switch(params.node.data.type) {
              case 'businessUnit':
                params.api.forEachNode((rowNode, index) => {
                  if (rowNode.data.type === 'Task' && rowNode.data.daysRemaning) deadlineChildTasks.push(rowNode)
                });
                return `<div class="dayRender">${deadlineChildTasks.length}</div>`
              case 'task' :
              case 'Task' :
                if (!params.value){
                  return `<img v-if="taskStatus" class="imageRender" src=${empty} />`
                } else {
                  return `<div class="dayRenderTask">${params.node.data.daysRemaning}</div>`
                }
              case 'MasterTask' :
                params.api.forEachNode((rowNode, index) => {
                  if (rowNode.data.type === 'Task' && rowNode.data.parentBusinessUnitTaskId === params.data.id && rowNode.data.daysRemaning) deadlineChildTasks.push(rowNode)
                });
                return `<div class="dayRender">${deadlineChildTasks.length}</div>`
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
          width:12
        },
        {
          headerName: "",
          field: "reccuringOverdue",
          // cellRenderer: "dayRenderer",
          tooltipField: "reccuringOverdue",
          tooltipComponentParams: function (params) {
            // console.log('params--', params)
            const rowNode = params.api.getDisplayedRowAtIndex(params.rowIndex);
            // console.log(rowNode)
            if (rowNode.data.type === 'Task') {
              let numb = params.value.toString().match(/\d/g);
              numb = numb.join("");
              console.log('!!! PARAMS !!!', numb)
              console.log('!!! PARAMS !!!', params.value[0])
              // if (params.value[0] === '(' && params.value[1] === '+') {
              //   return { fieldName: `Completed ${numb} Days Late` }
              // }
              //
              // if (params.value[0] === '(' && params.value[1] === '-') {
              //   return { fieldName: `Completed ${numb} Days Early` }
              // }

              // if (params.value === '(0)') {
              //   return { fieldName: `Completed on Time` }
              // }

              if (params.value === '0') {
                return { fieldName: `Recurring Now` }
              }

              if (params.value[0] === '+') {
                return { fieldName: `Overdue by ${numb} Days` }
              }

              if (params.value.toString() === '1'){
                return { fieldName: `Due in ${numb} Day` }
              }

              else {
                return { fieldName: `Recurring in ${numb} (D)`}
              }
            } else if (rowNode.data.type === 'MasterTask') {
              return {fieldName: `Master Task`}
            }
          },
          cellRenderer: function(params) {
            let reccuringChildTasks = [];
            switch(params.node.data.type) {
              case 'businessUnit':
                params.api.forEachNode((rowNode, index) => {
                  if (rowNode.data.type === 'Task' && rowNode.data.isReoccurring) reccuringChildTasks.push(rowNode)
                });
                return `<div class="dayRemaningRender">${reccuringChildTasks.length}</div>`
              case 'task' :
              case 'Task' :
                if (!params.node.data.isReoccurring){
                  return `<img v-if="taskStatus" class="imageRender" src=${empty} />`
                } else {
                  return `<div class="dayRenderTask">${params.node.data.reccuringOverdue}</div>`
                }
              case 'MasterTask' :
                params.api.forEachNode((rowNode, index) => {
                  if (rowNode.data.type === 'Task' && rowNode.data.parentBusinessUnitTaskId === params.data.id && rowNode.data.isReoccurring) reccuringChildTasks.push(rowNode)
                });
                return `<div class="dayRemaningRender">${reccuringChildTasks.length}</div>`
            }
          },
          cellClassRules: {
            "hover-over": params => {
              return params.node === potentialParent;
            }
          },
          width:12,
        },
        {
          headerName: "",
          field: "taskStatus",
          // cellRenderer: "taskStatusRenderer",
          tooltipField: "taskStatus",
          cellRenderer: function(params) {
            let childTasks = [];
            let doneCount = [];
            // different conditions for task and masterTask
            switch(params.node.data.type){
              case 'Task' :
              case 'task' :
                switch(params.node.data.taskStatus) {
                        // created
                  case 1:
                    return `<img v-if="taskStatus" class="imageRender" src=${empty} />`
                        //started
                  case 2:
                    // if in progress
                    if(params.node.data.progress) {
                      return `<img v-if="taskStatus" class="imageRender" src=${inProgress} />`
                    }else{
                      return `<img v-if="taskStatus" class="imageRender" src=${start} />`

                    }
                        // holded
                  case 3:
                    return `<img v-if="taskStatus" class="imageRender" src=${pause} />`
                        // done
                  case 4:
                    return `<img v-if="taskStatus" class="imageRender" src=${done} />`
                  case 5:
                    return `<img v-if="taskStatus" class="imageRender" src=${inProgress} />`
                }
                break;
              case 'MasterTask':
                params.api.forEachNode(function(rowNode, index) {
                  let childTask = '';
                  let doneChildTask = '';
                  if (rowNode.data.type === 'Task' && rowNode.data.hasProgress) {
                    childTask = rowNode.data.filePath.find(val => val === params.node.data.id.toString())
                  }
                  if (rowNode.data.type === 'Task' && rowNode.data.taskStatus === 4) {
                    doneChildTask = rowNode.data.filePath.find(val => val === params.node.data.id.toString())
                  }
                  if(childTask) childTasks.push(childTask);
                  if(doneChildTask) doneCount.push(doneChildTask)
                });
                // return `<img v-if="taskStatus" class="imageRender" src=${masterTaskIcon} />`
                return `<div class="progress--circle progress--0">
                        <div class="progress__number-mt">${doneCount.length}/${childTasks.length}</div>
                     </div>`
              case 'businessUnit':
                params.api.forEachNode(function(rowNode, index) {
                  if (rowNode.data.type === 'Task' && rowNode.data.hasProgress){
                    childTasks.push(rowNode.data)
                  }
                  if (rowNode.data.type === 'Task' && rowNode.data.taskStatus === 4){
                    doneCount.push(rowNode.data)
                  }
                });
                return `<div class="progress--circle progress--0">
                        <div class="progress__number-mt">${doneCount.length}/${childTasks.length}</div>
                     </div>`
                    // return `<img v-if="taskStatus" class="imageRender" src=${inProgress} />`
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
          tooltipComponentParams: { fieldName: "Task Status" },
          width: 12
        },
        {
          headerName: "",
          field: "progress",
          // cellRenderer: "progressRenderer",
          cellRenderer: function(params) {
            let childTasks = [];
            let doneCount = [];
            switch(params.node.data.type) {
              case 'businessUnit' :
                params.api.forEachNode(function(rowNode, index) {
                  if (rowNode.data.type === 'Task' && rowNode.data.hasProgress){
                    childTasks.push(rowNode.data)
                  }
                  if (rowNode.data.type === 'Task' && rowNode.data.progress === 100){
                    doneCount.push(rowNode.data)
                  }
                });
                return `<div class="progress--circle progress--0">
                        <div class="progress__number-mt">${doneCount.length}/${childTasks.length}</div>
                     </div>`
              case 'Task' :
              case 'task' :
                if (!params.node.data.hasProgress) {
                  return `<img v-if="taskStatus" class="imageRender" src=${empty} />`
                }
                return `<div class="progress--circle progress--${params.node.data.progress}">
                        <div class="progress__number">${params.node.data.progress}%</div>
                    </div>`
              case 'MasterTask' :
                params.api.forEachNode(function(rowNode, index) {
                  let childTask = '';
                  let doneChildTask = '';
                  if (rowNode.data.type === 'Task' && rowNode.data.hasProgress) {
                    childTask = rowNode.data.filePath.find(val => val === params.node.data.id.toString())
                  }
                  if (rowNode.data.type === 'Task' && rowNode.data.progress === 100) {
                    doneChildTask = rowNode.data.filePath.find(val => val === params.node.data.id.toString())
                  }
                  if(childTask) childTasks.push(childTask);
                  if(doneChildTask) doneCount.push(doneChildTask)
                });
                return `<div class="progress--circle progress--0">
                        <div class="progress__number-mt">${doneCount.length}/${childTasks.length}</div>
                     </div>`
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
          tooltipField: "progress",
          tooltipComponentParams: { fieldName: "Progress" },
          width: 12
        },
        // {
        //   headerName: '',
        //   field: "type",
        //   width: 12,
        //   cellClassRules: {
        //     "hover-over": function(params) {
        //       return params.node === potentialParent;
        //     }
        //   },
        //   cellRenderer: function(params) {
        //     if(params.node.data.type === 'businessUnit'){
        //       return `<span class="typeNameRenderer">B</span>`
        //     }else if (params.node.data.type === 'MasterTask'){
        //       return `<span class="typeNameRenderer">MT</span>`
        //     }else {
        //       return `<span class="typeNameRenderer">${params.node.data.type}</span>`
        //     }
        //   }
        // },
        {
          headerName: "",
          field: "timerCount",
          width: 15,
          // tooltipField: 'allowSharing',
          // resizable: true,
          cellRenderer: function(params) {
            switch(params.node.data.type) {
              case 'businessUnit':
                return `<img class="imageRender" src=${empty} />`
              case 'Task' :
              case 'task' :
                if(params.node.data.timerCount){
                  return `<div class="timerBlock">
                        <div class="el-badge item" id="badge">
                            <sup class="el-badge__content" >
                            ${params.node.data.timerCount}
                            </sup>
                        </div>
                        <img class="timerRender" src=${timer} />
                      </div>`
                }else {
                  return `<img class="imageRender" src=${empty} />`
                }
              case 'MasterTask' :
                return `<img v-if="taskStatus" class="imageRender" src=${empty} />`
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
        }
      ];
      this.rowSelection = "multiple";
      this.defaultColDef = {
        tooltipComponent: "customTooltip",
        suppressMovable: true,
        suppressMenu: true,
        resizable: true,
        editable: function (node){
          if(node.colDef.cellClass === 'name-cell' && node.data.type !== 'businessUnit'){
            return true
          }
        },
        onCellValueChanged : function (node){
          const that = this;
          if (!node.newValue) {
            console.log('>>', node)
            node.api.setFocusedCell(node.data.myIndex, node.colDef, false);
            node.api.startEditingCell({
              rowIndex: node.node.rowIndex,
              colKey: node.colDef,
              charPress: node.oldValue
            });
            return;
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          let uri = window.location.search.substring(1);
          let params = new URLSearchParams(uri);
          const companyId = params.get("companyId");
          axios.get(`/api/v1/businessUnitTasks/updateName?companyId=${companyId}&businessUnitId=${node.data.businessUnitId}&businessUnitTaskId=${node.data.id}&newName=${node.newValue}`)
                  .then(response => {
                  }).catch(err => {
            console.log(err)
          })
        },
      };
      this.components = { fileCellRenderer: getFileCellRenderer() };
      this.groupDefaultExpanded = -1;
      this.getDataPath = data => {
        return data.filePath;
      };
      this.getRowNodeId = data => {
        return data.id;
      };
      this.getRowHeight = params => {
        return 40;
      };
      this.autoGroupColumnDef = {
        rowDrag: function(params) {
          return !(params.data.id === 0)
        },
        headerName: this.$i18n.t('bu_name'),
        field: 'name',
        filter: "agTextColumnFilter",
        cellClass: 'name-cell',
        width: 110,
        cellRendererParams: {
          suppressCount: true,
          // innerRenderer: "fileCellRenderer"
          innerRenderer: function(params) {
            return `<span class="txtRender">${params.node.data.name}</span>`
          }
        },
        cellClassRules: {
          "hover-over": params => {
            return params.node === potentialParent;
          }
        }
      };
      this.frameworkComponents = {
        customTooltip: customTooltip
      };
      this.rowClassRules = {
        'no-access': '!data.access',
      };
    },
    mounted() {
      if (localStorage.getItem('isWorkDay')) {
        this.isWorkDay = true;
        this.getBusinessUnits(this.$route.query.companyId).then(data => {
          this.businessUnits = data
        });
        this.handleCommand('changeWorkDay');
        localStorage.removeItem('isWorkDay')
      }else if(this.$route.query.companyId){
        this.loadCompanyData(this.$route.query.companyId)
      }
      this.gridApi = this.gridOptions.api;
      console.log("GRID API", this.gridApi);
      this.gridColumnApi = this.gridOptions.columnApi;
      this.gridApi.sizeColumnsToFit();
      this.gridColumnApi.moveColumn("myIndex", 0);
      // setTimeout(() => {
      //   alert(this.businessUnitPermission.moveTask)
      //   this.gridApi.setSuppressRowDrag(this.businessUnitPermission.moveTask);
      // }, 3000);

      this.$options.sockets.companyInternalEvent = (data) => {
        if(!this.isWorkDay && this.valueBusinessUnit === data.businessUnitId && this.companyLayout.companyUserId !== data.companyUserId){
          switch (data.action) {
            case 'updateNameBUTask'://+
            case 'doneBUTask'://+
            case 'holdBUTask'://+
            case 'createBUTaskTimer'://+
              this.dynamicChangeRow(data.businessUnitTask, data.action);
              break;
            case 'updateBUTask'://+
            case 'startBUTask'://+
            case 'createBUTask'://+
            case 'createParentBUTask'://+
            case 'insertBUTask': //+
            case 'createBUTaskProgress'://+
            case 'changeBUTaskParent'://+
            case 'restartBUTask'://+
            case 'deleteBUTaskProgress'://+
            case 'updateBusinessUnitTaskList'://-
              new Promise (async (resolve, reject)=> {
                try {
                  this.rowData = await this.getTreeList(this.$route.query.companyId, data.businessUnitId);

                  // this.rowData = await this.buildNewTree(treeList);
                  resolve('ok')
                } catch (err){
                  console.log(err)
                }
              }).then(resultOfUpdate => {
                this.dynamicChangeData(data.businessUnitTaskId, data.action);
              });
              break;
            case 'deleteBUTask'://+
              this.dynamicDeleteFromData(data.businessUnitTaskId, data.action).then(async id => {
                try {
                  this.rowData = await this.getTreeList(this.$route.query.companyId, data.businessUnitId);
                  setTimeout(()=>{
                    if(this.selectedRow.id === id){
                      this.selectCreatedTask(this.rowData[0].id)
                    }else{
                      this.selectCreatedTask(this.selectedRow.id)
                    }
                  }, 1000)

                }catch(err){
                  console.log(err)
                }
              });
              break;
            case 'updateBU'://+
              try {
                new Promise (async (resolve, reject) => {
                  this.rowData = await this.getTreeList(this.$route.query.companyId, data.businessUnitId);

                  resolve('ok')
                }).then(data2 => {
                  this.onFlashRow(0).then(id => {
                    this.selectCreatedTask(id || this.rowData[0].id)
                  })
                });
              } catch (err) {
                console.log(err)
              }
              break;
            case 'deleteBU'://+
              this.rowData = [];
              this.valueBusinessUnit = '';
              this.valueBusinessCenter = ''
              this.selectedRow = {};
              localStorage.removeItem('selectedBusinessUnitId');
              this.$router.push(`/business-units?companyId=${this.$route.query.companyId}`);
              this.getBusinessUnits(this.$route.query.companyId);
              this.$alert('Business Unit was deleted!', 'Warning', {
                confirmButtonText: 'OK',
                type: 'info'
              });
              break
          }
        }
      }
    },
    data() {
      return {
        // document
        dialogVisible: false,
        documentList: {
          companyId: null,
          projectId: null,
          projectTaskId: null,
          type: '',
          taskType: '',
          level: null
        },
        firstEntering: false,
        currentTime: Number(moment().format('X')),
        width: 0,
        height: 0,
        isWorkDay:false,
        sharedBusinessUnittaskNoteId:'',
        companyNameSelect: '',
        projectInfo: {
          description: null,
          progress: 0,
          businessUnitCompanyVendorList: [],
          businessUnitCompanyClientList: []
        },
        taskInfo: {
          name: null,
          priority: {
            name: null
          },
          progress: 0,
          status: 0,
          businessUnitTaskCompanyVendorPersonList: [],
          businessUnitTaskCompanyClientPersonList: []
        },
        potentialParent: false,
        event: '',
        // BUSINESS UNITS START
        valueBusinessCenter: '',
        businessCenters: [],
        valueBusinessUnit: '',
        businessUnits: [],
        //BUSINESS UNITS END
        // open: false,

        activeInfoTab: 'first',
        activeTaskInfoTab: 'first',
        activeCRMTab: '',
        activeSCMTab: '',
        activeAccountTHINKTab: '',
        project: [],
        stages: [],
        region: [],
        activeBusinessUnitId: '',
        businessUnitTaskId: '0',
        // Modal form Edit Task
        formEditTask: {
          taskName: '',
          aboutThisTask: '',
          // taskStage: '',
          taskPriority: '',
          // startDate: '',
          // deadlineDate: '',
          assignedTo: '',
          taskTeam: '',

          allowExternalNotification: [],
          clients: '',
          vendors: '',

          assignSOP: '',
          assignPolicy: '',
          assignHealthSafety: '',
          assignRiskAssessment: '',
          assignEnvironmental: ''
        },

        // Tree
        gridOptions: null,
        gridApi: null,
        columnApi: null,
        columnDefs: null,
        rowData: [],
        getRowHeight: null,
        defaultColDef: null,
        components: null,
        groupDefaultExpanded: null,
        getDataPath: null,
        getRowNodeId: null,
        autoGroupColumnDef: null,
        rowSelection: null,
        frameworkComponents: null,
        rowClassRules: {},
        // Tabs
        progressData: false,
        selectedBusinessUnit: null,
        activeTab: 'first',
        isBusinessUnit: true,
        // isOnProgress: false,
        // newCreatedBusinessUnitTask: null,

        //selectedRow
        disabledBtn : true,
        selectedRows:null,
        selectedRow: {},
        selectedBusinessUnitForInfo:{},
        selectedTaskForInfo:{},
        bookmarkList:{},
        bookmarkListBusinessUnit:{},
        //business units permissions
        businessUnitPermission: {},
        expand: true
      }
    },
    methods: {
      openScheduler() {
        this.$refs.schedulerModal.openModal({entityId: this.$route.query.businessUnitId, type: 'bu'})
      },
      logRequest(action){
        log(`/api/v1/logs/create?companyId=${this.$route.query.companyId}`, {
          'action': action,
          'paramsLog': {
            buId: this.$route.query.businessUnitId,
            buTaskId: this.selectedRow.id
          }
        })
      },
      underDevelopment() {
        this.$refs.underDevelopment.open()
      },
      async loadCompanyData(companyId){
        try {
          //Load Client List
          this.getBusinessCenters();

          // Load Business Unit List
          const businessUnitList = await this.getBusinessUnits(companyId)

          //Check If Company Without Projects
          if(businessUnitList.length === 0){
            this.valueBusinessUnit = "";
            this.businessUnits = [];
          }else {
            this.businessUnits = businessUnitList
          }

          //Check If Business Unit Selected in route
          if(this.$route.query.businessUnitId){
            const rowData = await this.setBusinessUnitRowData(Number(this.$route.query.businessUnitId));
            this.activeInfoTab = 'first';

            //Select Active Row
            if(rowData.length > 0){
              const selectedRow = await this.selectCreatedTask(Number(this.$route.query.taskId) || 0)
            }

            //Select Active Tab
            switch (this.$route.query.tabName){
              case 'businessUnitInfoTab':
                this.activeTab = 'first';
                this.activeInfoTab = 'first';
                break;
              case 'businessUnitTaskInfoTab':
                this.activeTab = 'taskInfoTab';
                this.activeTaskInfoTab = 'first';
                break;
              case 'setShared':
                this.isBusinessUnit = false;
                this.activeTab = 'taskInfoTab';
                this.activeTaskInfoTab = 'progress';
                break;
              case 'createBusinessUnitComment':
                this.activeTab = 'businessUnitCommentTab';
                break;
              case 'createBusinessUnitTaskComment':
                this.activeTab = 'businessUnitTaskCommentTab';
                break;
              case 'createBusinessUnitMessage':
                this.activeTab = 'seven';
                break;
              case 'createBusinessUnitTaskMessage':
                this.activeTab = 'eight';
                break;
              case 'createBusinessUnitFile':
                this.activeTab = 'third';
                break;
              case 'createBusinessUnitTaskFile':
                this.activeTab = 'four';
                break;
              case 'createBusinessUnitMeeting':
                this.activeTab = 'nine';
                break;
              case 'createBusinessUnitTaskMeeting':
                this.activeTab = 'ten';
                break;
              case 'createBusinessUnitHistory':
                this.activeTab = 'eleven';
                break;
              case 'createBusinessUnitTaskHistory':
                this.activeTab = 'twelve';
                break;
              case 'reviewBusinessUnitTaskDocument':
                this.activeTab = 'taskInfoTab';
                this.activeTaskInfoTab = 'documents';
                // const activeDocumentTab = this.$route.query.activeDocumentTab;
                // setTimeout(()=>{
                //   this.$refs['taskInfoTab'].$refs.docs.selectTab(activeDocumentTab);
                // },1000);
                break;
              case 'createBusinessUnitCrm':
                this.activeTab = 'crm';
                this.activeCRMTab = 'sellingTask';
                break;
              case 'createBusinessUnitScm':
                this.isBusinessUnit = true;
                this.activeTab = 'scm';
                this.activeSCMTab = 'purchaseTask';
                break;
              case 'createBusinessUnitAccountTHINK':
                this.activeTab = 'aTHINK';
                this.activeAccountTHINKTab = 'budget';
                break;
              case 'businessUnitEngagementsTab':
                this.isBusinessUnit = true
                this.activeTab = 'first'
                this.activeInfoTab = 'six'
                break;
              case 'businessUnitProjectsTab':
                this.isBusinessUnit = true
                this.activeTab = 'first'
                this.activeInfoTab = 'seven';
                break;
            }
          }

        }catch(err){
          console.log('loadData', err)
        }
      },
      // document
      handleClose(done) {
        this.dialogVisible = false
      },
      signDocument() {
        this.dialogVisible = false;
        // this.activeTab = 'fourteen'
        switch (this.documentList.taskType) {
          case 'PROJECT':
            this.$router.push(`/projects?companyId=${this.documentList.companyId}&projectId=${this.documentList.projectId}&taskId=${this.documentList.projectTaskId}&tabName=reviewProjectTaskDocument&activeDocumentTab=${this.documentList.type}`);
            break;
          case 'ENGAGEMENT':
            this.$router.push(`/engagements/?companyId=${this.documentList.companyId}&engagementId=${this.documentList.projectId}&taskId=${this.documentList.projectTaskId}&tabName=reviewEngagementTaskDocument&activeDocumentTab=${this.documentList.type}`);
            break;
          default:
            if (this.$route.query.taskId.toString() === this.documentList.projectTaskId.toString()) {
              this.activeTab = 'taskInfoTab';
              this.activeTaskInfoTab = 'documents';
              // this.$refs['taskInfoTab'].$refs.docs.selectTab(this.documentList.type);
              this.$store.dispatch('getDocumentsBU', this.documentList.projectTaskId).then(data => {
                if (this.getStateId && this.getStateId === 'sop' ||
                        this.getStateId && this.getStateId === 'policy' ||
                        this.getStateId && this.getStateId === 'healthsafety' ||
                        this.getStateId && this.getStateId === 'riskAssesment' ||
                        this.getStateId && this.getStateId === 'general' ||
                        this.getStateId && this.getStateId === 'commercial' ||
                        this.getStateId && this.getStateId === 'envirenmental') {
                  // this.$refs['taskInfoTab'].$refs.docs.selectTab(this.documentList.type);
                  this.$refs['taskInfoTab'].$refs.docs.selectTab(this.getStateId);
                  this.$store.dispatch('setStateId', null)
                } else {
                  this.$store.dispatch('setStateId', null)
                }
              })
            } else {
              this.$router.push({query: {companyId: this.documentList.companyId, businessUnitId: this.documentList.projectId, taskId: this.documentList.projectTaskId, tabName: 'reviewBusinessUnitTaskDocument', activeDocumentTab: this.documentList.type}}).then(data => {
                console.log('this.$emit(rerenderMainLayout)');
                this.$emit('rerenderMainLayout')
              })
            }
        }
      },

      resize(newRect) {
        this.$refs.wrap__tree.classList.add("activeted");
        this.width = newRect.width;
        this.height = newRect.height;
      },
      changeWorkDay(val,event, activeTask){
        this.selectedRow = {};
        if(val){
          this.$store.dispatch('getCompanyLayout').then(response => {
          // alert('hello')
          // this.gridApi.setSuppressRowDrag(true);
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/businessUnitTaskWorkDayItems/list?companyId=${this.$route.query.companyId}&companyUserId=${response.companyUserId}`)
                  .then(response => {
                    this.gridApi.setRowData(response.data.list);
                    if (response.data.list.length) {
                      this.gridApi.forEachNode((node, index) =>  {
                        if (node.data.id === activeTask || node.data.id === response.data.list[0].id) {
                          this.gridApi.ensureIndexVisible(node.rowIndex, 'middle');
                          node.setSelected(true);
                        }
                      });
                    }
                    // this.rowData = response.data.list;
                    // if (response.data.list.length) {
                    //   setTimeout(() => {
                    //     this.selectCreatedTask(activeTask ||this.rowData[0].id)
                    //   }, 500)
                    // }
                    loader.hide()
                  })
                  .catch(error => {
                    loader.hide();
                    console.log('An error occurred:', error);
                  });
          })
        }else{
          // this.gridApi.setSuppressRowDrag(false);
          this.getBusinessCenters();
          if(this.selectedBusinessUnit){
            this.valueBusinessUnit = this.selectedBusinessUnit;
            this.setBusinessUnitRowDataInput(this.selectedBusinessUnit, 'first')
          }else{
            this.rowData = [];
            this.$router.push(`/business-units?companyId=${this.$route.query.companyId}`)
          }
        }
      },
      refreshTreeAfterDeleteTimer(businessUnitId){
        if(this.isWorkDay || this.valueBusinessUnit === businessUnitId){
          this.setBusinessUnitRowData(Number(this.$route.query.businessUnitId), 0, Number(this.$route.query.taskId));
        }
      },
      setActiveTabs(data){
        return new Promise (async (resolve, reject) => {
          try {
            switch (data.notificationType) {
              case 'businessUnitInfoTab':
                this.activeTab = 'first'
                this.activeInfoTab = 'first'
                resolve('success')
                break;
              case 'businessUnitTaskInfoTab':
                this.activeTab = 'taskInfoTab'
                this.activeTaskInfoTab = 'first'
                resolve('success')
                break;
              case 'createBusinessUnitComment' :
                this.activeTab = 'businessUnitCommentTab'
                resolve('success')
                break;
              case 'createBusinessUnitMessage' :
                this.activeTab = 'seven'
                resolve('success')
                break;
              case 'createBusinessUnitFile' :
                this.activeTab = 'third'
                resolve('success')
                break;
              case 'createBusinessUnitMeeting' :
                this.activeTab = 'nine'
                resolve('success')
                break;
              case 'createBusinessUnitHistory' :
                this.activeTab = 'eleven'
                resolve('success')
                break;
              case 'setShared' :
                this.activeTab = 'taskInfoTab'
                this.activeTaskInfoTab = 'progress'
                this.$refs.taskInfoTab.handleClick({name: 'progress'});
                resolve('success')
                break;
              case 'createBusinessUnitTaskComment' :
                this.activeTab = 'businessUnitTaskCommentTab';
                resolve('success')
                break;
              case 'createBusinessUnitTaskMessage' :
                this.activeTab = 'eight'
                resolve('success')
                break;
              case 'createBusinessUnitTaskFile' :
                this.activeTab = 'four'
                resolve('success')
                break;
              case 'createBusinessUnitTaskMeeting' :
                this.activeTab = 'ten'
                resolve('success')
                break;
              case 'createBusinessUnitTaskHistory' :
                this.activeTab = 'twelve'
                resolve('success')
                break;
              case 'reviewBusinessUnitTaskDocument' :
                this.activeTab = 'taskInfoTab'
                this.activeTaskInfoTab = 'documents'
                this.$refs['taskInfoTab'].$refs.docs.selectTab(data.stateId)
                resolve('success')
                break;
              case 'createBusinessUnitCrm':
                this.activeTab = 'crm'
                this.activeCRMTab = 'sellingTask'
                resolve('success')
                break;
              case 'createBusinessUnitScm':
                this.isBusinessUnit = true
                this.activeTab = 'scm'
                this.activeSCMTab = 'purchaseTask'
                resolve('success');
                break;
              case 'createBusinessUnitAccountTHINK':
                this.activeTab = 'aTHINK'
                this.activeAccountTHINKTab = 'budget'
                resolve('success')
                break;
              case 'businessUnitEngagementsTab':
                this.isBusinessUnit = true
                this.activeTab = 'first'
                this.activeInfoTab = 'six'
                resolve('success')
                break;
              case 'businessUnitProjectsTab':
                this.isBusinessUnit = true
                this.activeTab = 'first'
                this.activeInfoTab = 'seven'
                resolve('success')
                break;
              default:
                this.activeInfoTab = 'first'
                this.activeTaskInfoTab = 'first'
                resolve('success')
            }
          } catch (err) {
            console.log(err)
            reject(err)
          }
        });
      },
      closeMyWorkDay(){
        this.isWorkDay = false
        this.changeWorkDay(this.isWorkDay)
      },
      setMyWorkDay(){
        localStorage.setItem('isWorkDay', 'businessUnitWorkDayOpen')
      },
      handleCommand(command){
        switch (command) {
          case 'changeWorkDay':
            this.isWorkDay = true;
            this.changeWorkDay(this.isWorkDay);
            break;
          case 'addTask':
            this.getBusinessUnitDir('add');
            break;
          case 'editTask':
            this.getBusinessUnitDir('edit');
            break;
          case 'deleteTask':
            this.removeTask();
            break;
          case 'saveTaskTree':
            this.saveTaskTree();
            break;
          case 'duplicateTask':
            this.duplicateTask('duplicate')
            break;
          case 'addBusinessUnitExpense':
            this.openBusinessUnitExpense();
            break;
          case 'addTaskExpense':
            this.openBusinessUnitExpense();
            break;
          case 'createCashAdvance':
            this.openBusinessUnitCashAdvance();
            break;
          case 'createProject':
            this.openCreateProjectModal();
            break;
          case 'createEngagement':
            this.openCreateEngagementModal('create');
            break;
          case 'inviteUser':
            this.inviteUser();
            break;
          case 'addTaskTimer':
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/businessUnitTaskTimers/create?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&businessUnitTaskId=${this.selectedRow.id}`)
                .then(response => {
                    console.log('---/businessUnitTaskTimers/create', response.data);
                    this.$store.dispatch('getTimerListDep', {businessUnitId: this.$route.query.businessUnitId, businessUnitTaskId: this.selectedRow.id})
                    this.setBusinessUnitRowDataInput(Number(this.$route.query.businessUnitId), 0, Number(this.$route.query.taskId));
                    this.notification("Success", "Task start time", "success");
                    this.activeTab = 'first';
                    this.activeTaskInfoTab = 'progress'
                })
                .catch(error => {
                    console.log('An error occurred:', error);
                });
            break;
          case 'toggleBusinessUnitBookmark':
            this.changeBookMarkBusinessUnit(this.$route.query.companyId, this.$route.query.businessUnitId)
            break;
          case 'toggleBusinessUnitTaskBookmark':
            this.changeBookMarkTask(this.$route.query.companyId, this.$route.query.businessUnitId, this.selectedRow.id)
            break;
          default:
        }
      },
      getBusinessUnitDir(state){
        if(this.selectedRow.type === 'businessUnit'){
          this.$refs.createBusinessUnitTaskModal.openModal(state)
        }else if (this.selectedRow.type !== 'businessUnit' && state !== 'edit'){
          gridMessageBox.confirm('', this.$i18n.t('general_action'), {
            distinguishCancelAndClose: true,
            confirmButtonText: this.$i18n.t('general_addToParent'),
            cancelButtonText: this.$i18n.t('general_insertTask'),
            center: true
          })
                  .then(() => {
                    // check if user dont have permissions to create task
                    if (!this.businessUnitPermission.createTask) {
                      this.notification("Notification", "User Dont have permission to create task", "info");
                      return
                    }

                    if(state === 'add' && this.selectedRow.type === "Task" && this.selectedRow.taskStatus !== 1 && this.firstEntering === false){
                      this.$refs.addParent.open();
                      this.firstEntering = false
                    }else{
                      this.$refs.createBusinessUnitTaskModal.openModal(state)
                    }
                  })
                  .catch(action => {
                    // check if user dont have permissions to create task
                    if (!this.businessUnitPermission.createTask) {
                      this.notification("Notification", "User Dont have permission to create task", "info");
                      return
                    }
                    if (action === 'cancel'){
                      this.$refs.createBusinessUnitTaskModal.openModal('insert')
                    }
                  })
        }else{
          this.$refs.createBusinessUnitTaskModal.openModal(state)
        }
      },
      openAddTaskModal(){
        this.$refs.taskModal.addTask()
        this.$refs['taskModal'].open()
      },
      companyName(name) {
        this.companyNameSelect = name
      },
      refreshBlock(){
        this.valueBusinessCenter = '';
        this.valueBusinessUnit = '';
        this.rowData = [];
        this.disabledBtn = true;
        this.activeInfoTab = "first";
        this.getBusinessCenters();
        this.businessUnits = this.getBusinessUnits(this.$route.query.companyId);
      },
      getBusinessCenters(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
                .post(`/api/v1/businessCenters/list?companyId=${this.$route.query.companyId} `)
                .then(response => {
                  console.log('---', response.data);
                  this.businessCenters = response.data.list
                  this.businessCenters.unshift({name: 'All', id: 0})
                  loader.hide()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                });
      },
      getContextMenuItems(params) {
        if (params.node.data.id !== this.selectedRow.id && this.selectedRows.length === 1) {
          this.gridOptions.api.deselectAll();
        }
        this.selectCreatedTaskByRightClick(params.node.data.id)
        var _this = this;
        var data = params.node.data;
        var contextMenuItemList = [];
        if ((data.type === 'Task') || (data.type === 'MasterTask')) {
          if (this.selectedRows.length === 1) {
            if (!this.isWorkDay) {
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_addTask'),
                disabled: !this.businessUnitPermission.createTask,
                action: function () {
                  _this.getBusinessUnitDir('add')
                },
                icon: '<i class="el-icon-plus"></i>',
              });
            }
            if (!this.isWorkDay && data.type === 'Task') {
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_duplicateTask'),
                disabled: !this.businessUnitPermission.createTask,
                action: function () {
                  _this.duplicateTask('duplicate')
                },
                icon: '<i class="el-icon-plus"></i>',
              });
            }
            if (!this.isWorkDay) {
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_editTask'),
                disabled: !this.businessUnitPermission.updateTask,
                action: function () {
                  _this.getBusinessUnitDir('edit')
                },
                icon: '<i class="el-icon-edit"></i>',
              });
            }
            if (!this.isWorkDay) {
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_deleteTask'),
                disabled: !this.businessUnitPermission.deleteTask,
                action: function () {
                  _this.removeTask()
                },
                icon: '<i class="el-icon-delete"></i>',
              });
            }
            // if(data.type === 'task'){
            contextMenuItemList.push({
              name: this.$i18n.t('general_grid_contextMenu_inviteUser'),
              disabled: !this.companyLayout.permission.inviteUser,
              action: function () {
                _this.inviteUser();
                // console.log("Delete")
              },
              icon: '<i class="el-icon-plus"></i>',
            });
            // }
            if (data.type === 'Task' && data.taskStatus === 2 || data.type === 'Task' && data.taskStatus === 5) {
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_addTaskTimer'),
                action: function () {
                  _this.handleCommand('addTaskTimer');
                },
                icon: '<i class="el-icon-time"></i>',
              });
            }
          }else{
            contextMenuItemList.push({
              name: this.$t('general_grid_contextMenu_EditTeam'),
              action: function () {
                _this.$refs.ReassignTasksModal.editTaskListOpen();
              },
              icon: '<i class="el-icon-edit"></i>',
            },
            {
              name: this.$i18n.t('general_grid_contextMenu_addUsersToTeam'),
              action: function () {
              _this.$refs.addNewUserToTasksModal.addNewUsersOpen();
              },
              icon: '<i class="el-icon-edit"></i>',
            });
          }
        }
        if (data.type === 'businessUnit') {
          contextMenuItemList.push({
            name: this.$i18n.t('general_grid_contextMenu_addTask'),
            disabled: !this.businessUnitPermission.createTask,
            action: function () {
              _this.getBusinessUnitDir('add')
            },
            icon: '<i class="el-icon-plus"></i>',
          });
        }
        return contextMenuItemList;
      },
      getBusinessUnits(companyId){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/businessUnits/list?companyId=${companyId}`)
                  .then(response => {
                    resolve(response.data.list);
                    loader.hide()
                  })
                  .catch(error => {
                    reject(error)
                    console.log('An error occurred:', error)
                    loader.hide()
                  })
        })
      },
      getRowData(){

      },
      openShareProjectTask() {
        this.$refs.shareProjectTaskModal.$refs.shareProjectTaskModal.open();
      },
      TEST() {
        this.$refs.modal.createProjectOpen()
        this.$refs['modal'].$refs['createProject'].open()
      },
      async setValueBusinessUnits(id) {
        console.log('---', 'setValueBusinessUnits');
        if(!id){
          this.businessUnits = await this.getBusinessUnits(this.$route.query.companyId)
        }else{
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/businessUnits/list?companyId=${this.$route.query.companyId}&businessCenterId=${id}`)
                  .then(response => {
                    this.checkBusinessUnits(response.data.list)
                    console.log('BUSINESS UNITS', response.data)
                    console.log('BUSINESS UNITS LIST', response.data.list)
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error)
                    loader.hide()
                  })
        }
      },
      checkBusinessUnits(response){
        this.businessUnits = response
        if (this.businessUnits.length < 1){
          this.valueBusinessUnit = ""
          this.rowData = []
          this.selectedBusinessUnitForInfo = false
          this.selectedTaskForInfo = false
          this.activeTab = 'first'
          return
        }
        let myValDep = this.valueBusinessUnit
        for (let i = 0; i < response.length; i++){
          // console.log("VALUE PROJECT", myValProj, "RESPONSE ID", response[i].id, "!!!")
          this.valueBusinessUnit = response[i].id
          if(myValDep !== response[i].id){
            this.activeTab = 'first'
            this.valueBusinessUnit = ''
          }else if(myValDep === response[i].id){
            this.valueBusinessUnit = response[i].id
            return
          }
        }
        if(this.valueBusinessUnit === ''){
          this.rowData = []
          this.selectedBusinessUnitForInfo = false
          this.selectedTaskForInfo = false
        }
      },
      async setBusinessUnitRowDataInput(businessUnitId, state, newCreatedBusinessUnitTask, ifReocuring){
        const rowData = await this.setBusinessUnitRowData(businessUnitId, state, newCreatedBusinessUnitTask, ifReocuring)
        const selectedRow = await this.selectCreatedTask(newCreatedBusinessUnitTask || 0)
      },
      // SET BUSINESS UNITS INTO TABLE
      setBusinessUnitRowData(id, state, newCreatedProjectTask, ifReocuring) {
        return new Promise ((resolve, reject) => {
          if(this.isWorkDay){
            this.isWorkDay = false;
            this.getBusinessCenters();
            this.gridApi.setSuppressRowDrag(false);
            this.$message({
              type: 'info',
              message: this.$t('general_workdayClosed')
            });
            // this.changeWorkDay(this.isWorkDay, false, newCreatedProjectTask)
            // return
          }

          let loader = this.$loading.show();
          this.selectedBusinessUnit = Number(id);
          localStorage.setItem('selectedBusinessUnitId', this.selectedBusinessUnit);
          this.valueBusinessUnit = Number(id);
          if(state === "first") {
            this.$router.push(`/business-units?companyId=${this.$route.query.companyId}&businessUnitId=${id}&taskId=0`)
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/businessUnitTasks/list?companyId=${this.$route.query.companyId}&businessUnitId=${id}`)
                  .then(response => {
                    if(!response.data.newList[0].businessUnitBusinessCenterList.length) {
                      this.valueBusinessCenter = 0
                    } else if(this.valueBusinessCenter !== 0) {
                      this.valueBusinessCenter = response.data.newList[0].businessUnitBusinessCenterList[0]
                    }
                    this.rowData = this.buildNewTree(response.data.newList);
                    resolve(this.rowData);
                    loader.hide();
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        })
      },
      selectCreatedTask(id) {
        return new Promise ((resolve, reject) => {
          let that = this;
          let ifUserHaveAccesstoTask = false;
          this.gridApi.forEachNode(function(node) {
            // CHECK IF USER HAVE ACCESS TO TE ROW
            if (node.data.id === id && node.data.access) {
              // SET TO TRUE IF HAVE ACCESS
              ifUserHaveAccesstoTask = true;
              // MOVE TASK TO MIDDLE CENTER
              that.gridApi.ensureIndexVisible(node.rowIndex, 'middle');
              node.setSelected(true);
              console.log("NODE SELECTED");
              resolve(node)
            }
          });

          // CHECK IF USER SELECTED TASK WITH ACCESS IF NOT SELECT FIRST TASK WITH ACCESS
          if (!ifUserHaveAccesstoTask) {
            const accessedRows = that.rowData.filter(val => val.access);
            if(accessedRows.length) {
              this.selectCreatedTask(accessedRows[0].id)
            }
          }
        })
      },
      selectCreatedTaskNotification(id) {
        return new Promise ((resolve, reject) => {
          this.gridOptions.api.deselectAll();
          let that = this;
          let ifUserHaveAccesstoTask = false;
          this.gridApi.forEachNode(function (node, index) {
            // CHECK IF USER HAVE ACCESS TO TE ROW
            if (node.data.id === id && node.data.access) {
              // SET TO TRUE IF HAVE ACCESS
              ifUserHaveAccesstoTask = true;
              // MOVE TASK TO MIDDLE CENTER
              that.gridApi.ensureIndexVisible(node.rowIndex, 'middle');
              node.setSelected(true, true);
              resolve(node)
            }
          });
          // CHECK IF USER SELECTED TASK WITH ACCESS IF NOT SELECT FIRST TASK WITH ACCESS
          if (!ifUserHaveAccesstoTask) {
            const accessedRows = that.rowData.filter(val => val.access);
            if(accessedRows.length) {
              this.selectCreatedTask(accessedRows[0].id)
            }
          }

        })
      },
      selectCreatedTaskByRightClick(id) {
        return new Promise ((resolve, reject) => {
          this.gridApi.forEachNode(function(node) {
            if (node.data.id === id) {
              node.setSelected(true);
              resolve(node)
            }
          });
        })
      },
      openInfo(active, id){
        // alert("openInfo")
        this.activeInfoTab = active;
        this.getDepatmentInfo(id);
      },
      find(array, value) {
        for (var i = 0; i < array.length; i++) {
          if (array[i].id == value) return true;
        }
        return false
      },
      taskNotFoundOpenMadal(){
        this.$refs.taskNotFound.open()
        setTimeout(() => {
          this.activeTab = 'first'
          this.activeInfoTab= 'first'
          this.gridOptions.api.deselectAll();
          this.selectCreatedTask(0)
          this.$refs.taskNotFound.close()
        }, 2000)
      },
      onRowDragMove(event) {
        setPotentialParentForNode(event.api, event.overNode);
      },
      onRowDragLeave(event) {
        setPotentialParentForNode(event.api, null);
      },
      onRowDragEnd(event) {

        // CHECK IF DROP TASK TO ITSELF
        if (event.node.id === potentialParent.id) {
          setPotentialParentForNode(event.api, null);
          return
        }

        this.potentialParent = potentialParent;
        this.event = event;

        switch(potentialParent.data.type) {
          case 'businessUnit':
            this.notification("Info", "DnD Action not allowed for Business Unit task", "info");
            setPotentialParentForNode(event.api, null);
            break;
          case 'MasterTask':
            // check if potential parent is parent of moved task
            if (potentialParent.id === event.node.parent.id) this.openActionModalForStartedTasks(event);

            else this.openActionModalForMasterTask(event);
            break;
          case 'Task':
            // IF TASK NOT STARTED
            if (potentialParent.data.taskStatus === 1) this.openActionModalForMasterTask(event);
            // IF TASK STARTED
            else this.openActionModalForStartedTasks(event)
        }
      },
      openActionModalForMasterTask(event){
        gridMessageBox.confirm('', 'Action', {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Add to parent',
          cancelButtonText: 'Move Task',
          center: true
        })
                .then(() => {
                  // when select
                  if(this.potentialParent.id !== 0){
                    this.createParentTask('0')
                  }
                  // disable highlighted when click btn
                  setPotentialParentForNode(event.api, null);
                })
                .catch(action => {
                  // when select move task
                  if (action === 'cancel'){
                    this.createParentTask('1')
                  }
                  // disable highlighted when click btn
                  setPotentialParentForNode(event.api, null);
                })
      },
      openActionModalForStartedTasks(event){
        gridMessageBox.alert('', 'Action', {
          confirmButtonText: 'Move Task',
          center: true
        })
                .then(() => {
                  // when select
                  this.createParentTask('1');
                  // disable highlighted when click btn
                  setPotentialParentForNode(event.api, null);
                })
                .catch(action => {
                  // when select move task
                  setPotentialParentForNode(event.api, null);
                })
      },
      createParentTask(state){
        const potentialParent = this.potentialParent
        const event = this.event;
        if (!potentialParent) {
          return;
        }else if(potentialParent.data.type === "Task" && potentialParent.data.taskStatus === 2 && state === '0' ||
                 potentialParent.data.type === "Task" && potentialParent.data.taskStatus === 5 && state === '0'){
          this.$refs.dragEnd.close();
          this.notification("Notification", "TASK ALREADY STARTED", "info")
          setPotentialParentForNode(event.api, null);
          return
        }else if(potentialParent.data.timerCount && state === '0'){
          this.$refs.dragEnd.close()
          this.notification("Notification", "STOP TIMER", "info")
          setPotentialParentForNode(event.api, null);
          return
        }
        console.log(potentialParent, 'BOOOOOOM');
        let parentId = '';
        if (potentialParent.id === 0) {
          parentId = null
        } else {
          parentId = potentialParent.id
        }
        var movingData = event.node.data;
        var newParentPath = potentialParent.data ? potentialParent.data.filePath : [];
        var needToChangeParent = !arePathsEqual(newParentPath, movingData.filePath);
        var invalidMode = isSelectionParentOfTarget(event.node, potentialParent);
        if (invalidMode) {
          console.log("invalid move");
        }

        let isPutChild = true
        for (let i = 0; i < potentialParent.data.filePath.length; i++){
          if(movingData.id.toString() === potentialParent.data.filePath[i]){
            this.$refs.dragEnd.close()
            this.notification("Notification", "YOU SHALL NOT PASS!!", "info")
            console.log(movingData, 'MOVING DATA');
            console.log(potentialParent, 'Potential PARENT');
            isPutChild = false
          }
        }

        console.log(isPutChild, 'IS PUT CHILD');
        if (needToChangeParent && !invalidMode && isPutChild) {
          var updatedRows = [];
          moveToPath(newParentPath, event.node, updatedRows);
          this.gridApi.updateRowData({update: updatedRows});
          this.gridApi.clearFocusedCell();
          console.log('potentialParent.data.orderIndex', state)
          this.dragTaskEnd(this.$route.query.companyId, this.$route.query.businessUnitId, movingData.id, parentId, state, potentialParent.data.orderIndex)
        }
        setPotentialParentForNode(event.api, null);
      },
      dragTaskEnd(companyId, businessUnitId, selectedRowId, parentId, state, orderIndex){
        this.$refs.dragEnd.close();
        if(state === '1'){

          const parentOfHoveredTask = this.rowData.filter(val => val.id === parentId)[0];
          parentId = parentOfHoveredTask.parentBusinessUnitTaskId;

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/businessUnitTasks/changeParent?companyId=${companyId}&businessUnitId=${businessUnitId}&businessUnitTaskId=${selectedRowId}&move=${state}&businessUnitTaskOrderIndex=${orderIndex}`, {
            newParentBusinessUnitTaskId: parentId
          })
                  .then(response => {
                    if(response.data.success){
                      this.notification("Success", "Moved Task", "success");
                      loader.hide()
                      this.setBusinessUnitRowDataInput(Number(businessUnitId), false, selectedRowId);
                    }
                  })
                  .catch(error => {
                    loader.hide()
                    this.notification("Notification", error.response.data.message, "info");
                    console.log('An error occurred:', error);
                  })
        }else{
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/businessUnitTasks/changeParent?companyId=${companyId}&businessUnitId=${businessUnitId}&businessUnitTaskId=${selectedRowId}&move=${state}&businessUnitTaskOrderIndex=${orderIndex}`, {
            newParentBusinessUnitTaskId: parentId
          })
                  .then(response => {
                    if(response.data.success){
                      loader.hide();
                      this.notification("Success", "TASK ADDED TO PARENT", "success");
                      this.setBusinessUnitRowDataInput(Number(businessUnitId), false, selectedRowId)
                    }
                  })
                  .catch(error => {
                    loader.hide()
                    this.notification("Notification", error.response.data.message, "info")
                    console.log('An error occurred:', error);
                  })
        }
      },
      duplicateTask(state){
        this.$confirm(this.$i18n.t('general_doYouWantToDuplicateThisTask'), '', {
          confirmButtonText: this.$i18n.t('general_yes'),
          cancelButtonText: this.$i18n.t('general_cancel'),
          type: 'info'
        }).then(() => {
          try {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.get(`/api/v1/businessUnitTasks/duplicate?companyId=${this.$route.query.companyId}&businessUnitId=${this.selectedRow.businessUnitId}&businessUnitTaskId=${this.selectedRow.id}`)
                    .then(response => {
                      loader.hide();
                      this.$message({
                        type: 'success',
                        message: 'Duplication completed'
                      });
                      this.setBusinessUnitRowDataInput(this.selectedRow.businessUnitId, false, response.data.buTaskId)
                    }).catch(err => {
              loader.hide();
              console.log(err)
            });
          }catch(err){
            console.log(err)
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Duplication canceled'
          });
        });
      },
      onGridReady(params) {},
      onSelectionChanged() {
        // check if really row selected or deselectAll()
        if (!this.gridApi.getSelectedRows().length) return;

        this.disabledBtn = false;
        this.selectedRows = this.gridApi.getSelectedRows();
        this.selectedRow = this.selectedRows[0];
        this.activeBusinessUnitId = this.selectedRow.businessUnitId;

        this.$router.replace(`/business-units?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeBusinessUnitId}&taskId=${this.selectedRow.id}`);

        if(this.selectedRow.type === 'businessUnit'){
          //CLICK TABLE
          this.isBusinessUnit = true;
          this.getBusinessUnitLayout(this.$route.query.companyId, this.selectedRow.businessUnitId);
          if(this.activeTab === 'taskInfoTab'){
            this.activeTab = 'first'
          }
          if(this.activeTab === 'four'){
            this.activeTab = 'third'
          }
          if(this.activeTab === 'businessUnitTaskCommentTab'){
            this.activeTab = 'businessUnitCommentTab'
          }
          if(this.activeTab === 'second'){
            // alert('her')
            this.activeTab = 'first'
          }
          if(this.activeTab === 'eight'){
            this.activeTab = 'seven'
          }
          if(this.activeTab === 'ten'){
            this.activeTab = 'nine'
          }
          if(this.activeTab === 'twelve'){
            this.activeTab = 'eleven'
          }
          // Documents
          // if(this.activeTab === 'fourteen'){
          //   this.activeTab = 'first'
          // }

          switch (this.activeTab) {
            case 'first':
              // check active info tab inside tab
              switch (this.activeInfoTab){
                case 'first':
                  this.getDepatmentInfo(this.selectedRow.id);
                  break;
                case 'five':
                  this.$store.dispatch('getBusinessUnitHistory');
                  break;
                case 'six':
                  this.$store.dispatch('getBusinessUnitEngagementList', this.selectedRow.businessUnitId);
                  // get new code list
                  this.$refs.infoTab.$refs.businessUnitEngagementsTab.getCodesList()
                  break;
                case 'seven':
                  this.$store.dispatch('getBusinessUnitProjectsList', this.selectedRow.businessUnitId);
                  break;
                case 'permissions':
                  this.$store.dispatch('getBusinessUnitPermissionsList', this.selectedRow.businessUnitId);
                  this.$refs.infoTab.loadPermissionData();
                  break;
                case 'about':
                  this.$store.dispatch('about', 'bu')
                  break;
              }
              // history
              console.log('ACTIVE BUSINESS UNIT INFO TAB')
              break;
            case 'second':
              console.log("BUSINESS UNIT PROGRESS TAB SELECTED")
              break;
            case 'third':
              console.log("BUSINESS UNIT FILES TAB SELECTED")
              this.$store.dispatch('getBusinessUnitFiles')
              break;
            case 'businessUnitCommentTab':
              console.log("BUSINESS UNIT COMMENTS TAB SELECTED")
              this.$store.dispatch('getBusinessUnitComments').then(list => {
                if (list.length && this.getStateId) {
                  const selectedComment = list.filter(val => val.id === this.getStateId);
                  if (selectedComment.length) this.$refs.businessUnitCommentTab.selectActiveCommentNode(this.getStateId);
                  this.$store.dispatch('setStateId', null)
                } else {
                  this.$store.dispatch('setStateId', null)
                }
              });
              break;
            case 'seven':
              this.$store.dispatch('getMessagesDirectories', {'type': 'businessUnit', 'businessUnitId': this.activeBusinessUnitId})
              this.$store.dispatch('getMessagesList', {'type': 'businessUnit', 'businessUnitId': this.activeBusinessUnitId, 'projectMessageType': '1'})
              break;
            case 'nine':
              console.log("BUSINESS UNIT MEETINGS TAB SELECTED")
              // this.$store.dispatch('getBusinessUnitMeetings')
              this.getDepatmentInfo()
              this.$store.dispatch('getMeetings', {companyId: this.$route.query.companyId, parentId: this.activeBusinessUnitId, typeId: 2, taskId: null, page: 1}).then(list => {
                if (list.length && this.getStateId) {
                  const selectedMeeting = list.filter(val => val.id === this.getStateId);
                  if (selectedMeeting.length) this.$refs.businessUnitMeetingTab.selectActiveMeetingNode(this.getStateId);
                  this.$store.dispatch('setStateId', null)
                } else {
                  this.$store.dispatch('setStateId', null)
                }
              });
              break;
            case 'eleven':
              console.log("BUSINESS UNIT HISTORY TAB SELECTED")
              this.$store.dispatch('getBusinessUnitHistory')
              break;
          }
        }else if(this.selectedRow.type === 'MasterTask' || this.selectedRow.type === 'Task'){
          this.isBusinessUnit = false;
          this.getTaskLayout(this.$route.query.companyId, this.selectedRow.businessUnitId, this.selectedRow.id);
          if(this.activeTab === 'first'){
            this.activeTab = 'taskInfoTab'
          }
          if(this.activeTab === 'third'){
            this.activeTab = 'four'
          }
          if(this.activeTab === 'businessUnitCommentTab'){
            this.activeTab = 'businessUnitTaskCommentTab'
          }
          if(this.selectedRow.type === 'MasterTask'&& this.activeTab === 'second'){
            this.activeTab = 'first'
          }
          if(!this.selectedRow.hasProgress && this.activeTab === 'second'){
            this.activeTab = 'first'
          }
          if(this.activeTab === 'seven'){
            this.activeTab = 'eight'
          }
          if(this.activeTab === 'nine'){
            this.activeTab = 'ten'
          }
          if(this.activeTab === 'eleven'){
            this.activeTab = 'twelve'
          }
          // if permission selected before
          if(this.activeTab === 'first' && this.activeInfoTab === 'permissions'){
            this.activeInfoTab = 'first'
          }

          switch (this.activeTab) {
            case 'taskInfoTab':
              this.getBusinessUnitTaskInfo();
              switch (this.activeTaskInfoTab) {
                case 'eight':
                  this.$store.dispatch('getBusinessUnitTaskHistory', this.selectedRow.id);
                  break;
                case 'progress':
                  if (this.selectedRow.type === 'MasterTask' || !this.selectedRow.hasProgress) {
                    this.activeTaskInfoTab = 'first';
                    this.getBusinessUnitTaskInfo();
                  } else {
                    this.getDepProgressList(this.selectedRow.id);
                    this.$store.dispatch('getTimerListDep', {businessUnitId: this.activeBusinessUnitId, businessUnitTaskId: this.selectedRow.id})
                  }
                  break;
                case 'documents':
                  this.$store.dispatch('getDocumentsBU', this.selectedRow.id).then(data => {
                    if (this.getStateId && this.getStateId === 'sop' ||
                            this.getStateId && this.getStateId === 'policy' ||
                            this.getStateId && this.getStateId === 'healthsafety' ||
                            this.getStateId && this.getStateId === 'riskAssesment' ||
                            this.getStateId && this.getStateId === 'general' ||
                            this.getStateId && this.getStateId === 'commercial' ||
                            this.getStateId && this.getStateId === 'envirenmental') {
                      this.$refs['taskInfoTab'].$refs.docs.selectTab(this.getStateId);
                      this.$store.dispatch('setStateId', null)
                    } else {
                      this.$store.dispatch('setStateId', null)
                    }
                  });
                  break;
                case 'toDo':
                  this.$store.dispatch('toDo', 'bu')
                  break;
                case 'about':
                  this.$store.dispatch('about', 'buTask')
                  break;
              }
              break;
            case 'second':
              console.log("BUSINESS UNIT TASK PROGRESS TAB SELECTED")
              this.getDepProgressList(this.selectedRow.id);
              this.$store.dispatch('getTimerListDep', {businessUnitId: this.activeBusinessUnitId, businessUnitTaskId: this.selectedRow.id})
              break;
            case 'four':
              console.log("BUSINESS UNIT TASK FILES TAB SELECTED")
              this.$store.dispatch('getDepTaskFiles', this.selectedRow.id )
              break;
            case 'businessUnitTaskCommentTab':
              this.$store.dispatch('getBusinessUnitTaskComments', this.selectedRow.id).then(list => {
                if (list.length && this.getStateId) {
                  const selectedComment = list.filter(val => val.id === this.getStateId);
                  if (selectedComment.length) this.$refs.businessUnitTaskCommentTab.selectActiveCommentNode(this.getStateId);
                  this.$store.dispatch('setStateId', null)
                } else {
                  this.$store.dispatch('setStateId', null)
                }
              });
              break;
            case 'eight':
              this.$store.dispatch('getMessagesDirectories', {'type': 'taskBusinessUnit', 'businessUnitId': this.activeBusinessUnitId, 'businessUnitTaskId': this.selectedRow.id})
              this.$store.dispatch('getMessagesList', {'type': 'taskBusinessUnit', 'businessUnitId': this.activeBusinessUnitId, 'businessUnitTaskId': this.selectedRow.id, 'projectTaskMessageType': '1'})
              if(this.$refs.MessagesTask){
                this.$refs.MessagesTask.currentTabComponent = 'MessagesReceived'
              }
              break;
            case 'ten':
              this.getBusinessUnitTaskInfo()
              // this.$store.dispatch('getBusinessUnitTaskMeetings', {businessUnitId: this.activeBusinessUnitId, taskId: this.selectedRow.id})
              this.$store.dispatch('getMeetings', {companyId: this.$route.query.companyId, parentId: this.activeBusinessUnitId, typeId: 5, taskId: this.selectedRow.id, page: 1}).then(list => {
                if (list.length && this.getStateId) {
                  const selectedMeeting = list.filter(val => val.id === this.getStateId);
                  if (selectedMeeting.length) this.$refs.businessUnitTaskMeetingTab.selectActiveMeetingNode(this.getStateId);
                  this.$store.dispatch('setStateId', null)
                } else {
                  this.$store.dispatch('setStateId', null)
                }
              });
              break;
            case 'twelve':
              this.$store.dispatch('getBusinessUnitTaskHistory', this.selectedRow.id)
              break;
            // case 'fourteen':
            //   this.$store.dispatch('getDocumentsBU', this.selectedRow.id)
            //   break;
          }
        }
      },
      getBusinessUnitLayout(companyId, businessUnitId){
        return new Promise ((resolve, reject) =>{
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/businessUnitLayout/getData?companyId=${companyId}&businessUnitId=${businessUnitId}`)
                  .then(response => {
                    this.bookmarkListBusinessUnit = response.data.bookmarks;
                    this.businessUnitPermission = response.data.permission;

                    //check drag and drop from permissions
                    this.gridApi.setSuppressRowDrag(!this.businessUnitPermission.moveTask);

                    if (response.data.document) {
                      // check if document set later
                      if (response.data.document.date) {
                        this.openLaterConfirmDocumentModal(response.data.document);
                        loader.hide();
                        return
                      }
                      this.documentList.companyId = response.data.document.companyId;
                      this.documentList.projectId = response.data.document.businessUnitId;
                      this.documentList.projectTaskId = response.data.document.businessUnitTaskId;
                      this.documentList.taskType = response.data.document.taskType;
                      if (response.data.document.type === 'riskassesment') {
                        this.documentList.type = 'commercial'
                      } else if (response.data.document.type === 'envirenmental') {
                        this.documentList.type = 'general'
                      } else {
                        this.documentList.type = response.data.document.type
                      }
                      // this.documentList.type = response.data.document.type
                      this.signInDocumentOpenModal(response.data.document.id);

                    } else {
                      if (this.$session.has('documentId')) this.$session.remove('documentId');
                    }
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        })
      },
      getTaskLayout(companyId, businessUnitId, taskId){
        return new Promise ((resolve, reject) =>{
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/businessUnitTaskLayout/getData?companyId=${companyId}&businessUnitId=${businessUnitId}&businessUnitTaskId=${taskId}`)
                  .then(response => {
                    this.bookmarkList = response.data.data.bookmarks;
                    this.businessUnitPermission = response.data.permission;

                    //check drag and drop from permissions
                    if (this.isWorkDay) this.gridApi.setSuppressRowDrag(true);
                    else this.gridApi.setSuppressRowDrag(!this.businessUnitPermission.moveTask);

                    if (response.data.document) {
                      // check if document set later
                      if (response.data.document.date) {
                        this.openLaterConfirmDocumentModal(response.data.document);
                        loader.hide();
                        return
                      }
                      this.documentList.companyId = response.data.document.companyId;
                      this.documentList.projectId = response.data.document.businessUnitId;
                      this.documentList.projectTaskId = response.data.document.businessUnitTaskId;
                      this.documentList.taskType = response.data.document.taskType;
                      if (response.data.document.type === 'riskassesment') {
                        this.documentList.type = 'commercial'
                      } else if (response.data.document.type === 'envirenmental') {
                        this.documentList.type = 'general'
                      } else {
                        this.documentList.type = response.data.document.type
                      }
                      // this.documentList.type = response.data.document.type
                      if (!this.$session.has('documentId')) {

                        this.signInDocumentOpenModal(response.data.document.id);

                      } else {
                        const documentId = this.$session.get('documentId');
                        const documentIdFromRequest = response.data.document.id;

                        if (documentId !== documentIdFromRequest) {
                          this.signInDocumentOpenModal(response.data.document.id);
                        } else {
                          this.$session.remove('documentId')
                        }
                      }
                    } else {
                      if (this.$session.has('documentId')) this.$session.remove('documentId');
                    }
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        })
      },
      signInDocumentOpenModal(documentId){
        this.$alert(this.$t('modal_documents_youHaveDocumentsThatRequireAction'), this.capitalizeFirstLetter(this.documentList.type), {
          confirmButtonText: this.$t('general_ok'),
          showClose: false,
          callback: action => {
            switch (action){
              case 'confirm':
                this.$session.set('documentId', documentId);
                this.$store.dispatch('setStateId', this.documentList.type);
                this.signDocument();
                break;
              case 'cancel':
                this.$session.remove('documentId');
                break
            }
          }
        });
      },
      openLaterConfirmDocumentModal(document){
        this.$refs.laterDocumentModal.openModal(document)
      },
      getDepatmentInfo(id){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnits/extendedInfo?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}`)
          .then(response => {
            console.log('---/businessUnits/extendedInfo', response.data.extendedInfo);
            response.data.extendedInfo.businessUnitCompanyUserList.sort(function (a, b) {
              if (a.userFullName.toLowerCase() > b.userFullName.toLowerCase()) {
                return 1;
              }
              if (a.userFullName.toLowerCase() < b.userFullName.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.businessUnitCompanyClientList.sort(function (a, b) {
              if (a.companyClient.name.toLowerCase() > b.companyClient.name.toLowerCase()) {
                return 1;
              }
              if (a.companyClient.name.toLowerCase() < b.companyClient.name.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.businessUnitCompanyVendorList.sort(function (a, b) {
              if (a.companyVendor.name.toLowerCase() > b.companyVendor.name.toLowerCase()) {
                return 1;
              }
              if (a.companyVendor.name.toLowerCase() < b.companyVendor.name.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            this.projectInfo = response.data.extendedInfo
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      getBusinessUnitTaskInfo(){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnitTasks/extendedInfo?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&businessUnitTaskId=${this.selectedRow.id}`)
          .then(response => {
            console.log('---/businessUnitTasks/extendedInfo', response.data.extendedInfo);
            response.data.extendedInfo.businessUnitCompanyUserList.sort(function (a, b) {
              if (a.userFullName.toLowerCase() > b.userFullName.toLowerCase()) {
                return 1;
              }
              if (a.userFullName.toLowerCase() < b.userFullName.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.businessUnitTaskCompanyUserList.sort(function (a, b) {
              if (a.userFullName.toLowerCase() > b.userFullName.toLowerCase()) {
                return 1;
              }
              if (a.userFullName.toLowerCase() < b.userFullName.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.businessUnitTaskCompanyClientList.sort(function (a, b) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            response.data.extendedInfo.businessUnitTaskCompanyVendorList.sort(function (a, b) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              return 0;
            });

            this.taskInfo = response.data.extendedInfo
            this.isBusinessUnit = false
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      getDepProgressList(id){
        this.$store.dispatch('getDepProgressesList', id).then(list => {
          if (list.length && this.getStateId) {
            const progressItem = list.filter(val => val.id === this.getStateId);
            if (progressItem) {
              this.$refs.taskInfoTab.$refs.buProgressTab.selectActiveProgressNode(this.getStateId);
            } else {
              this.$store.dispatch('setStateId', null)
            }
          }
        })
      },
      addTask() {
      },
      closeAddNewTask(){

      },
      editTask() {
        console.log('---', 'edit');
        this.$refs.editTask.open();
      },
      shareTask() {

        console.log('---', 'share');
      },
      async removeTask() {
        try {
          if (this.selectedRow.type === 'MasterTask') return this.notification(this.$t('general_warning'), this.$t('modal_notification_cantDeleteMasterTask'), "info");

          // check if current task has documents
          const documents = await this.$store.dispatch('getDocumentsBU', this.selectedRow.id);
          let ifDocumentsAttached = false;
          if (documents.envirenmental || documents.healthsafety || documents.policy || documents.riskAssesment || documents.sop) ifDocumentsAttached = true;

          this.$confirm(ifDocumentsAttached ? this.$t('modal_businessUnit_afterDeletingBusinessUnitTaskAttachedDocumentsWillBeDeletedTooContinue') : this.$t('modal_businessUnit_thisWillPermanentlyDeleteTheBusinessUnitTaskContinue'), this.$t('general_warning'), {
            confirmButtonText: this.$t('general_ok'),
            cancelButtonText: this.$t('general_cancel'),
            type: 'info'
          }).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('general_deleteCompleted'),
            });

            let loader = this.$loading.show();
            console.log('---', 'remove');
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/businessUnitTasks/delete?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}&businessUnitTaskId=${this.selectedRow.id}`)
                    .then(response => {
                      console.log('deleted task', response.data);
                      let id = this.activeBusinessUnitId;
                      if (response.data.success) {
                        this.setBusinessUnitRowDataInput(id, 'first');
                      }
                      loader.hide()
                    })
                    .catch(error => {
                      loader.hide();
                      console.log('An error occurred:', error);
                    });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('general_deleteCanceled')
            });
          });
        } catch (err){
          console.log(err)
        }
      },
      dynamicChangeRow(changedRow, action){
          var itemsToUpdate = [];
          var newItem = changedRow;
          let indexItem = 0;
          this.gridApi.forEachNodeAfterFilterAndSort(function(rowNode, index) {
            if (rowNode.data.id === changedRow.id ) {
              indexItem = index
              var data = rowNode.data;
              data.name = changedRow.name;
              data.taskStatus = changedRow.status;
              data.taskTeamList = changedRow.taskTeamList;
              data.hasProgress = changedRow.hasProgress;
              data.progress = changedRow.progress;
              data.timerCount = changedRow.timerCount;
              if (changedRow.leader) {
                data.leader = changedRow.leader === null ? null : changedRow.leader.user
              }
              itemsToUpdate.push(data);
            }
          });
          // TODO COMMIT 28/02/2020
          this.gridApi.updateRowData({ update: itemsToUpdate });
          this.onFlashRow(indexItem).then(id => this.selectCreatedTask(id ||this.rowData[0].id))
      },
      getTreeList(companyId, businessUnitId){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        return axios.post(`/api/v1/businessUnitTasks/list?companyId=${companyId}&businessUnitId=${businessUnitId}`)
                .then(response => {
                  const newList = this.buildNewTree(response.data.newList);
                  console.log('newList', newList)
                  return newList;
                }).catch(err => {
                  console.log(err)
                })
      },
      buildNewTree(list){
        // DECLARE MANAGER (LEADER) OF PROJECT
        let ifUserLeader = false;
        let ifUserManager = false;
        // CHECK USER ACCESS TO PROJECT START
        const companyUserId = this.companyLayout.companyUserId.toString();
        const even = (element) => element === companyUserId;
        // CHECK IF USER LEADER OF BU NOT JUST MANAGER
        ifUserLeader = list[0].leader.id === this.user.user.id;
        // TODO CHECK IF USER MANAGER OF BU
        ifUserManager = list[0].userList.some(even);

        for (let i = 0; i < list.length; i++) {
          if (ifUserManager && i === 0) {
            list[i].access = true
          }else if (!ifUserManager && i === 0) {
            list[i].access = false
          }else if (i > 0) {
            if (this.user.user.id === list[i].creatorId) {
              list[i].access = true
            }else {
              list[i].access = list[i].taskTeamList.some(even)
            }
          }

          if (ifUserLeader) {
            list[i].access = true
          }
          // add my index
        }
        return list
      },
      async getTreeScreen(){
        try {
          let loader = this.$loading.show();
          let eGridDiv = await document.querySelector('#myGrid');
          eGridDiv.style.height = '';
          await this.gridApi.setDomLayout('print');
          const canvas = await html2canvas(document.querySelector("#myGrid"));
          const fileUrl = await new Promise((resolve) => {
          const that = this;
            canvas.toBlob(function(blob) {
              try {
                const formData = new FormData();
                formData.append('file', blob, 'filename.png');
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios
                        .post(`/api/v1/files/create?companyId=${that.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
                        .then(response => {
                          resolve(response.data.fileUrl);
                        }).catch(error => {
                  loader.hide();
                  console.log('An error occurred:', error);
                });
              } catch (err){
                loader.hide();
                console.log(err)
              }
            });
          });
          eGridDiv.style.height = '100%';
          eGridDiv.style.width = '100%';
          await this.gridApi.setDomLayout(null);
          loader.hide();
          await this.$refs['modal777'].submitFormFileUrl(fileUrl)
        }catch (err){
          console.log(err)
        }
      },
      async dynamicChangeData(businessUnitTaskId, action){
        try {
          const taskIndex = await this.buildNewRowData2(businessUnitTaskId);
          console.log('!!!!taskIndex', taskIndex);

          const taskId = await this.onFlashRow(taskIndex);
          console.log('!!!!taskId', taskId);

          const selectedNode = await this.selectCreatedTask(taskId ||this.rowData[0].id);
          console.log('!!!!selectedNode', selectedNode);
        } catch (err){
          console.log(err)
        }
      },
      buildNewRowData2(businessUnitTaskId) {
        return new Promise((resolve, reject) => {
          this.gridApi.forEachNode(function(node, index) {
            if(businessUnitTaskId === node.data.id){
              resolve(index)
            }
          })
        })
      },
      onFlashRow(index) {
        return new Promise((resolve, reject) => {
          var rowNode = this.gridApi.getDisplayedRowAtIndex(index);
          this.gridApi.flashCells({
            rowNodes: [rowNode]
          });
          resolve(this.selectedRow.id)
        })
      },
      dynamicDeleteFromData(businessUnitTaskId, action){
        return new Promise ((resolve, reject) =>{
            this.buildNewRowData2(businessUnitTaskId).then(index => this.onFlashRowDelete(index)).then(id => {
                resolve(id)
            })
        })
      },
      onFlashRowDelete(index) {
        return new Promise((resolve, reject) => {
          var rowNode = this.gridApi.getDisplayedRowAtIndex(index);
          this.gridApi.flashCells({
            rowNodes: [rowNode]
          });
          resolve(rowNode.id)
        })
      },
      saveTaskTree() {
        this.$refs['modal777'].$refs['saveTaskTreeProject'].open()
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      handleClick(tab, event){
        if(tab.name === 'first'){
          this.getDepatmentInfo(this.$route.query.businessUnitId);
          this.$store.dispatch('getBusinessUnitHistory');
          this.logRequest('log_bu_info')
        }else if (tab.name === 'taskInfoTab') {
          this.getBusinessUnitTaskInfo();
          this.$store.dispatch('getBusinessUnitTaskHistory', this.selectedRow.id)
          this.logRequest('log_bu_task_info')
        }else if(tab.name === 'second'){
          this.getProgressesList(this.selectedRow.id);
          this.$store.dispatch('getTimerListDep', {businessUnitId: this.activeBusinessUnitId, businessUnitTaskId: this.selectedRow.id})
          this.logRequest('log_bu_task_progress')
        }else if(tab.name === 'third'){
          this.$store.dispatch('getBusinessUnitFiles')
          this.logRequest('log_bu_files')
        }else if(tab.name === 'four'){
          this.$store.dispatch('getDepTaskFiles', this.selectedRow.id)
          this.logRequest('log_bu_task_files')
        }else if(tab.name === 'businessUnitCommentTab'){
          this.$store.dispatch('getBusinessUnitComments', this.selectedRow.id)
          this.logRequest('log_bu_comments')
        }else if(tab.name === 'businessUnitTaskCommentTab'){
          this.$store.dispatch('getBusinessUnitTaskComments', this.selectedRow.id)
          this.logRequest('log_bu_task_comments')
        }else if(tab.name === 'seven'){
          this.$store.dispatch('getMessagesDirectories', {'type': 'businessUnit', 'businessUnitId': this.activeBusinessUnitId})
          this.$store.dispatch('getMessagesList', {'type': 'businessUnit', 'businessUnitId': this.activeBusinessUnitId, 'projectMessageType': '1'})
          this.logRequest('log_bu_messages')
        }else if(tab.name === 'eight'){
          this.$store.dispatch('getMessagesDirectories', {'type': 'taskBusinessUnit', 'businessUnitId': this.activeBusinessUnitId, 'businessUnitTaskId': this.selectedRow.id})
          this.$store.dispatch('getMessagesList', {'type': 'taskBusinessUnit', 'businessUnitId': this.activeBusinessUnitId, 'businessUnitTaskId': this.selectedRow.id, 'projectTaskMessageType': '1'})
          this.logRequest('log_bu_task_messages')
        }else if(tab.name === 'nine'){
          // this.$store.dispatch('getBusinessUnitMeetings')
          this.$store.dispatch('getMeetings', {companyId: this.$route.query.companyId, parentId: this.activeBusinessUnitId, typeId: 2, taskId: null, page: 1})
          this.logRequest('log_bu_meetings')
        }else if(tab.name === 'ten'){
          this.$store.dispatch('getMeetings', {companyId: this.$route.query.companyId, parentId: this.activeBusinessUnitId, typeId: 5, taskId: this.selectedRow.id, page: 1})
          // this.$store.dispatch('getBusinessUnitTaskMeetings', {businessUnitId: this.activeBusinessUnitId, taskId: this.selectedRow.id})
          this.logRequest('log_bu_task_meetings')
        }else if(tab.name === 'eleven') {
          this.$store.dispatch('getBusinessUnitHistory')
          this.logRequest('log_bu_history')
        }else if(tab.name === 'twelve') {
          this.$store.dispatch('getBusinessUnitTaskHistory', this.selectedRow.id)
          this.logRequest('log_bu_task_history')
        }
        // else if(tab.name === 'fourteen'){
        //   this.$store.dispatch('getDocumentsBU', this.selectedRow.id)
        // }
      },
      getProgressesList(id) {
        this.$store.dispatch('getDepProgressesList', id).then(list => {
          if (list.length && this.getStateId) {
            const progressItem = list.filter(val => val.id === this.getStateId);
            if (progressItem) {
              this.$refs.taskInfoTab.$refs.buProgressTab.selectActiveProgressNode(this.getStateId);
            } else {
              this.$store.dispatch('setStateId', null)
            }
          }
        })
      },
      inviteUser() {
        this.$refs.inviteUserModal.openModalFromBasic('getBusinessUnitList', this.$route.query.businessUnitId, this.selectedRow.id);
      },
      openBusinessUnitExpense(){
        this.$refs['businessUnitExpenseModal'].openModal('businessUnitTaskExpenses')
      },
      openBusinessUnitCashAdvance(){
        this.$refs['businessUnitCashAdvanceModal'].openModal('businessUnitTasksCashAdvance')
      },
      openCreateProjectModal() {
        this.$refs['createProjectModal'].openModal()
      },
      openCreateEngagementModal(state) {
        this.$refs['createEngagementModal'].addEngagement(state)
      },
      setNewPermissions(permissions){
        this.businessUnitPermission = permissions
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      expandAll(){
        this.expand = !this.expand;
        if(this.expand){
          this.gridApi.forEachNode((node) => {
            node.setExpanded(true);
          })
        }else {
          this.gridApi.forEachNode((node) => {
            if(node.data.filePath.length === 2) {
              node.setExpanded(false);
            }
          })
        }
      },
      changeBookMarkBusinessUnit(companyId, businessUnitId){
        this.$confirm(this.bookmarkListBusinessUnit.info ? this.$t('bu_removeBookmark') : this.$t('bu_addBookmark'), this.$t('general_info'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          let data = this.bookmarkListBusinessUnit
          data.info = !this.bookmarkListBusinessUnit.info
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/bookmarks/setBusinessUnit?companyId=${companyId}&businessUnitId=${businessUnitId}`, data)
              .then(response => {
                if (this.bookmarkListBusinessUnit.info) {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
                } else {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
                }
              })
              .catch(error => {
              });
        }).catch(err=> {
          console.log('err', err)
        })
      },
      changeBookMarkTask(companyid, businessUnitId, taskId) {
        this.$confirm(this.bookmarkList.info ? this.$t('bu_removeBookmark') : this.$t('bu_addBookmark'), this.$t('general_info'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          let data = this.bookmarkList;
          data.info = !this.bookmarkList.info;
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/bookmarks/setBusinessUnitTask?companyId=${companyid}&businessUnitId=${businessUnitId}&businessUnitTaskId=${taskId}`, data)
              .then(response => {
                if (this.bookmarkList.info) {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
                } else {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
                }
              })
              .catch(error => {
              });
        }).catch(err => {
          console.log('err', err)
        })
      }
    },
    watch:{
      rowData(val) {
        if (val.length === 0) {
          this.disabledBtn = true
        } else {
          this.disabledBtn = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sweet-modal-overlay{
    z-index:1000;
  }

  .business-units {
    background: #DfE8F0;
    z-index: 0;
    height: 100vh;
  }

  .content {
    display: flex;
    height: 100vh;
    padding-top: 50px;
  }

  .el-tabs{
    height:calc(100% - 73px);
  }

  // [ Wrapper ] start
  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 0 10px 10px 10px;
  }
  .wrap {
    display: flex;
    width: 100%;
    height: 100%;
    &__tree {
      width:100%;
      height:100%;
      // max-width: 634px;
      // min-width:634px;
      max-width: 700px;
      min-width: 700px;
      min-height:100%;
      padding: 0 10px 10px 0;
      &.activeted{
        width:auto;
        height:100%;
        min-width:auto;
      }
    }
    &__info {
      max-width:100%;
      width: 100%;
      min-width:50%;
      padding: 0 0 10px 10px;
      .nav-project{
        height:73px;
      }
    }
  }
  // [ Wrapper ] end

  // [ Nav tree ] start
  .nav-project {
    max-height:73px;
    display:flex;
    max-height:73px;
    justify-content:space-between;
    width:100%;
    padding: 20px 0px 20px 0;
    overflow:hidden;
    &__item {
      margin: 0 0 5px 0;
    }
    &_first-row{
      display:flex;
      justify-content: flex-start;
    }
    .el-select {
      margin-right: 10px;
    }
  }
  .nav-tree {
    &__item {
      margin: 0 0 5px 0;
    }
    .el-button {
      margin-right: 10px;
    }
  }
  #fade-in {
    /*transition: all .50s ease;*/
    width: 100%;
    /*height:32px;*/
    /*opacity: 1;*/
    //overflow:hidden;
    display: flex;
    //.inputs{
    //  /deep/.el-input__inner{
    //    width:180px;
    //  }
    //}
    .select-wrapper {
      position: relative;
      .t-label {
        position: absolute;
        cursor: pointer;
        color: #4277A6;
        font-size: 14px;
        top: -12px;
      }
    }
  }
  /*#fade-in.hide {*/
    /*overflow:hidden;*/
    /*opacity: 0;*/
    /*transition: all .50s ease;*/
    /*width: 1px;*/
    /*height:32px;*/
  /*}*/
  .work-day-block{
    z-index:1;
    width:100%;
    .close-work-day-btn{
      margin-right:10px;
    }
  }
  .vuedrag{
    /*width:100%;*/
    height:100% !important;
    position:relative;
  }
  .vdr.active:before{
    outline:none;
  }
  /deep/.ag-theme-balham .ag-cell.ag-cell-inline-editing{
    height:100%;
    .ag-input-text-wrapper{
      height:100%;
    }
  }
  /deep/.vdr-stick-mr{
    /*background-color:transparent;*/
    /*border:none;*/
    /*box-shadow:none;*/
    /*&:before{*/
    /*font-family: "Font Awesome 5 Free";*/
    /*content: '\F337';*/
    /*position: absolute;*/
    /*font-weight: 900;*/
    /*right: -9px;*/
    /*font-size: 25px;*/
    /*top: -10px;*/
    /*}*/
  }
  // [ Nav tree ] end
  .input-recuring-counter{
    /*margin-left:10px;*/
    width:50px;
  }
</style>

<style lang="less" scoped>
  .btn-wrap{
    position:relative;
    .star{
      color:#F56C6C;
      position:absolute;
      left: -20px;
      font-size:19px !important;
      font-weight:inherit;
    }
  }
  .repeat{
    width:100px;
  }
  .datepicker{
    width:100px;
  }
  .demo-ruleForm{
    text-align:left;
  }
  .flex-center{
    display: flex;
    justify-content: center;
  }
  .flex{
    display: flex;
    justify-content:space-between;
  }
  .two-columns > div{
    max-width:45%;
    width:100%;
  }
  .el-form-item{
    .el-select{
      width:100%;
    }
  }
  .draggble{
    display:flex;
    flex-direction:column;
    text-align:center;
    align-items:center;
    justify-content: center;
    .btn{
      width:120px;
      margin:5px 0;
    }
  }
  /*.flex-end{*/
    /*display:flex;*/
    /*justify-content: flex-end;*/
  /*}*/
  .task-not-found-block{
    text-align:center;
  }
  .fade-enter{
    opacity: 0;
  }
  .fade-enter-active{
    transition: opacity 1s;
  }
  .fade-leave{
    /* opacity: 1; */
  }
  .fade-leave-active{
    transition: opacity 1s;
    opacity: 0;
  }
  .disabled {
      // background: #f2f2f2;
      color: red !important;
  }
  /deep/.timerBlock{
    width: 28px;
    height: 28px;
    position:relative;
    margin-top: calc(50% - 18px);
    & #badge{
      z-index:1;
      position:absolute;
      top: -5px;
      right: -4px;
      & .el-badge__content{
        font-size:10px;
        height: 17px;
        padding: 0 5px;
      }
    }
  }

  /deep/.timerRender{
    width:100%;
    height:100%;
    position: absolute;
    border-radius: 20px;
  }
  /deep/.no-access{
    background-color: #ebeef5 !important;
  }
  /deep/.dayRender {
    background: #68a8e2;
    border-radius: 1.8em;
    -moz-border-radius: 1.8em;
    -webkit-border-radius: 1.8em;
    color: #ffffff;
    display: inline-block;
    font-weight: bold;
    line-height: 3.0em;
    margin-right: 5px;
    text-align: center;
    width: 28px;
    height: 28px;
    font-size: 10px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  /deep/.dayRenderTask {
    border: 3px solid #ddd;
    border-radius: 1.8em;
    -moz-border-radius: 1.8em;
    -webkit-border-radius: 1.8em;
    box-sizing: border-box;
    display: flex;
    justify-content:center;
    align-items:center;
    font-weight: bold;
    line-height: 3.0em;
    margin-right: 5px;
    text-align: center;
    width: 28px;
    height: 28px;
    font-size: 10px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
</style>

<style>
  .deleted-modal{
    z-index:999999 !important;
  }
  .hover-over {
    background-color: #e5e5ff;
  }

  .el-tabs--border-card>.el-tabs__content {
    height: 90% !important;
    overflow-y: auto;
  }
  .txtRender {
    color: black !important;
  }
</style>
